<template>
  <div>
    <!--<section
      @click="onClickHandler"
      id="sectionId"
      class="d-flex body-content new-addendee-list"
      style="
        background-image: url('https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FEvent%20Background_2732x2048%20pixels.jpg?alt=media');
      "
    >-->
    <section
      @click="onClickHandler"
      id="sectionId"
      :class="
        isAdminComponent
          ? 'd-flex body-content new-addendee-list self-service-attendee-wrap attendee_List self-service-pad-wrap'
          : 'd-flex body-content new-addendee-list attendee_List network_list'
      "
      style="background-color: #f1f3f4"
    >
      <div class="container-fluid">
        <div
          :class="
            isAdminComponent && finalAttendeeList.length == 0 && !IsLoading
              ? 'd-none setup-attendee-block'
              : 'setup-attendee-block d-none'
          "
        >
          <h3>Setup Attendee</h3>
          <div class="active-mode-switch">
            <p>Private Mode</p>
            <v-switch color="#1a73e8" v-model="switch71"></v-switch>
          </div>
          <p>Private Event - Attendees must be invited</p>
        </div>
        <!---attendee intro screen start--->

        <div
          class="blank-expo-section"
          v-if="
            isAdminComponent && finalAttendeeList.length == 0 && !searchtext
          "
        >
          <img src="../assets/Images/self-service/attendee_add.png" />
          <h3 class="mt-3">Add Attendee</h3>
          <p class="mt-3">
            Start by inviting attendees to your event. You can update avatar,
            name, email, headline, bio and social profiles. You can also use the
            bulk import option and send bulk mails to attendees after you have
            added them !
          </p>
          <v-btn
            dark
            color="#1a73e8"
            class="save-standard mt-3"
            @click="openAttendeeAddDialog()"
            ><v-icon size="20px" color="#ffffff">mdi-plus</v-icon> Add New
            Attendee</v-btn
          >
        </div>
        <!---attendee intro screen end--->
        <!----top area-->

        <div
          class="row"
          v-if="
            (isAdminComponent &&
              (finalAttendeeList.length != 0 || searchtext)) ||
            !isAdminComponent
          "
        >
          <div
            class="col-md-6 mb-22 d-flex justify-content-start align-items-center"
          >
            <h1 id="headerText" class="page-head text-uppercase my-0">
              <v-autocomplete
                style="background: white"
                v-if="$route.path.includes('mainlobby')"
                dense
                outlined
                v-model="attendeeEvent"
                :items="$store.state.MappedEvent"
                prepend-inner-icon="search"
                return-object
                hide-details
                label="Select Event"
                item-text="EventFullName"
              ></v-autocomplete>
              <template v-else>
                {{ headerText }}
              </template>
            </h1>
            <div
              v-if="
                (ShowFilter || ShowFilterQuery) &&
                DynamicFilterOptions.length > 0
              "
            >
              <button
                @click="toggleFilter"
                :class="
                  hasFilter
                    ? 'attendee-filter-btn has-filter ml-2'
                    : 'attendee-filter-btn ml-2'
                "
              >
                {{ $t("attendee.filter") }}
              </button>

              <div
                v-show="filterDisplayState"
                v-if="
                  (ShowFilter || ShowFilterQuery) &&
                  DynamicFilterOptions.length > 0
                "
                @click="preventHideFilter"
                class="resources-left-filter-hld custom-radios custom-filter-right"
              >
                <div class="clear-filter d-flex">
                  <span class="filter-header">{{
                    $t("attendee.filters")
                  }}</span>
                  <span
                    v-show="hasFilter"
                    class="clear-btn mr-8"
                    @click="clearAllFilter"
                    >{{ $t("attendee.clearall") }}</span
                  >
                  <span
                    class="close-btn-filter"
                    @click="filterDisplayState = false"
                  >
                    <v-icon> mdi-close </v-icon>
                  </span>
                </div>
                <div id="filterContent" class="category-wrapper">
                  <div
                    v-for="item in DynamicFilterOptions"
                    :key="item.id"
                    class="select-box"
                  >
                    <h5
                      :id="'a_' + item.id"
                      data-toggle="collapse"
                      :href="'#' + item.id"
                      @click="collapseOtherFilters(item.id)"
                      aria-expanded="false"
                      class="filter-group"
                    >
                      {{ item.DisplayLabel }}
                      <span v-show="item.badge > 0" class="badge">{{
                        item.badge
                      }}</span>
                    </h5>
                    <div
                      class="language-box filter-group-content in collapse"
                      :id="item.id"
                    >
                      <div
                        v-for="option in item.Options"
                        :key="option"
                        class="checkbox-hld"
                      >
                        <input
                          :type="item.AllowMultiSelect ? 'checkbox' : 'radio'"
                          :id="item.id + '_' + option"
                          :name="item.FieldName"
                          :value="option"
                          @change="filterAttendee"
                          class="dynamic-filter-option"
                        />
                        <label :for="item.id + '_' + option">
                          <span>
                            <img
                              src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg"
                              alt="Checked Icon"
                            />
                          </span>
                          {{ option }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-----headdingg end--->
          <!-- mobile search button -->
          <div class="d-block d-md-none">
            <button class="mob_search_button" v-on:click="mob_alist_search()">
              <img
                src="../assets/Images/icons/search-black.svg"
                alt="e2m"
                width="20px"
              />
            </button>
          </div>
          <!-- mobile search button end -->
          <div class="col-md-6 mob-pt-0">
            <div class="row justify-content-end mob-my-0">
              <div class="col-md-12 mb-md-3 mob-py-0" @click="hideFilter">
                <!----top search start----->
                <div class="right-search-hld" id="mob_att_search">
                  <div
                    v-if="ShowSearch || ShowSearchQuery"
                    class="position-relative fixed-w full-width search-hld"
                  >
                    <!--<input
                        id="InputSearch"
                        type="text"
                        @keyup="searchAttendee"
                        v-on:keydown.enter.prevent="searchAttendee"
                        v-model="searchtext"
                        :placeholder="$t('attendee.searchplaceholder')"
                      />-->
                    <input
                      id="InputSearch"
                      v-model="searchtext"
                      type="text"
                      :placeholder="$t('attendee.searchplaceholder')"
                      v-on:keydown.enter.prevent="searchAttendee"
                    />
                    <div class="reset-search-btn">
                      <p v-if="searchtext" @click="searchtext = ''">
                        <v-icon dark small color="#8a8a8a">mdi-close</v-icon>
                      </p>
                    </div>
                  </div>
                  <a
                    data-analytics
                    data-page-name="/attendee"
                    data-action="click"
                    :data-action-label="'Attendee Search: ' + searchtext"
                    href="javascript:void(0)"
                    @click="searchAttendee"
                    v-if="ShowSearch || ShowSearchQuery"
                    >GO</a
                  >
                </div>
                <!----top search end---->
              </div>
              <!--<div
                v-if="ShowFilter && DynamicFilterOptions.length > 0"
                class="col-md-2 mb-3 pl-md-1"
              >
                <div style="float: right">
                  <button
                    @click="toggleFilter"
                    :class="
                      hasFilter
                        ? 'attendee-filter-btn has-filter ml-2'
                        : 'attendee-filter-btn ml-2'
                    "
                  >
                    {{ $t("attendee.filter") }}
                  </button>
                </div>
              </div>-->

              <!----resources-left-filter-hld start----->
              <!--<div
                v-show="filterDisplayState"
                v-if="ShowFilter && DynamicFilterOptions.length > 0"
                @click="preventHideFilter"
                class="resources-left-filter-hld custom-radios custom-filter-right"
              >
                <div class="clear-filter d-flex">
                  <span class="filter-header">{{
                    $t("attendee.filters")
                  }}</span>
                  <span
                    v-show="hasFilter"
                    class="clear-btn"
                    @click="clearAllFilter"
                    >{{ $t("attendee.clearall") }}</span
                  >
                </div>
                <div id="filterContent" class="category-wrapper">
                  <div
                    v-for="item in DynamicFilterOptions"
                    :key="item.id"
                    class="select-box"
                  >
                    <h5
                      :id="'a_' + item.id"
                      data-toggle="collapse"
                      :href="'#' + item.id"
                      @click="collapseOtherFilters(item.id)"
                      aria-expanded="false"
                      class="filter-group"
                    >
                      {{ item.DisplayLabel }}
                      <span v-show="item.badge > 0" class="badge">{{
                        item.badge
                      }}</span>
                    </h5>
                    <div
                      class="language-box filter-group-content in collapse"
                      :id="item.id"
                    >
                      <div
                        v-for="option in item.Options"
                        :key="option"
                        class="checkbox-hld"
                      >
                        <input
                          :type="item.AllowMultiSelect ? 'checkbox' : 'radio'"
                          :id="item.id + '_' + option"
                          :name="item.FieldName"
                          :value="option"
                          @change="filterAttendee"
                          class="dynamic-filter-option"
                        />
                        <label :for="item.id + '_' + option">
                          <span>
                            <img
                              src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg"
                              alt="Checked Icon"
                            />
                          </span>
                          {{ option }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>-->
            </div>
          </div>
        </div>
        <!--top area end-->
        <div class="legend" @click="hideFilter">
          <ul
            class="p-0 m-0 d-md-flex align-items-center"
            v-if="showAttendeeLegend == true && regTypes.length > 2"
          >
            <li
              class="attendee-legend-list mr-xs-0"
              style="margin-right: 10px; cursor: unset"
            >
              {{ $t("attendee.quickfilter") }}:
            </li>
            <li
              v-for="reg in regTypes"
              :key="reg.RegistrationTypeId"
              :class="
                selectedLegendRegType == reg.RegistrationType
                  ? 'attendee-legend-list selected'
                  : 'attendee-legend-list'
              "
              :data-tag="reg.RegistrationType"
              @click="filterAttendeeByRegType(reg.RegistrationType)"
            >
              <label
                v-if="reg.RegistrationTypeId"
                class="legend-attendee"
                :style="[reg.ColorCode ? { background: reg.ColorCode } : {}]"
              ></label>
              {{ reg.RegistrationType }}
            </li>
          </ul>
        </div>

        <div class="resources-inner-main-wrapper d-flex" @click="hideFilter">
          <!------resources- filter body area start-------->
          <div class="resources-filter-body pl-0">
            <div id="dvAttendeeWrapper" class="row attendee-list-box-wrapper">
              <!--add attendee start--->
              <!-- <div
                v-if="isAdminComponent"
                class="col-6 col-md-6 col-lg-3 col-elg-2 ate_list_main"
                @click="OpenAddAttendeePopup"
              >
                <div class="attendee-box-hld f-center ss-add-plus-box">
                  <a>
                    <img
                      src="../assets/Images/icons/add-new-blue.svg"
                      alt="e2m"
                    />
                    <h3>Add Attendee</h3>
                  </a>
                </div>
              </div> -->
              <!---add attendee end-->
              <!----attendee box start---->
              <div
                v-for="(attendee, index) in finalAttendeeList"
                :key="attendee.id"
                v-bind:id="attendee.id"
                :class="
                  isAdminComponent
                    ? 'attendee-list-self-service p-md-0 p-lg-0 col-12 col-md-12 col-lg-12 col-elg-12 ate_list_main'
                    : 'col-6 col-md-4 col-lg-3 col-elg-2 ate_list_main'
                "
                v-on:click="
                  openModal(
                    attendee.id,
                    attendee.Name,
                    attendee.Company,
                    attendee.Title,
                    attendee.Image,
                    attendee.Email,
                    attendee.Phone,
                    attendee.Website,
                    attendee.Profile,
                    attendee.SocialLinks,
                    attendee.Initials,
                    attendee.RegistrationType,
                    attendee.DynamicFields,
                    attendee
                  );
                  AddEventAnalytics({
                    pageName: '/attendee',
                    action: 'click',
                    actionType: '',
                    actionLabel:
                      'attendee/' + attendee.id + '/' + attendee.Name,
                  });
                "
              >
                <div
                  :class="
                    isAdminComponent
                      ? 'attendee-box-hld single-box-attendee-hld position-relative'
                      : 'attendee-box-hld new-list-show single-box-attendee-hld position-relative'
                  "
                  style="overflow: hidden"
                  :id="'dv' + attendee.id"
                  @mouseover="
                    !isAdminComponent
                      ? getBookmarkStatus(
                          attendee.id,
                          attendee.Name,
                          attendee.Image,
                          attendee.isBookmarked,
                          attendee.isLoading
                        )
                      : ''
                  "
                >
                  <div
                    v-if="loggedInUseID != attendee.id"
                    class="attendee-bottom-option position-absolute"
                  >
                    <ul>
                      <li
                        v-if="OneToOneChatEnabled"
                        :id="attendee.AttendeeKey"
                        :key="attendee.AttendeeKey"
                        @click.stop.once="
                          OpenOneToOneChat(attendee);
                          AddEventAnalytics({
                            pageName: '/attendee',
                            action: 'click',
                            actionType: '',
                            actionLabel: 'OneToOneChat: ' + attendee.Name,
                          });
                        "
                      >
                        <v-btn
                          elevation="0"
                          fab
                          dark
                          small
                          :color="attendee.StartingChat ? 'grey' : '#eef1f4'"
                          :loading="attendee.StartingChat"
                          ><img
                            src="../assets/Images/landing/message-network.svg"
                            style="height: 20px; width: 20px"
                        /></v-btn>
                        <p>{{ $t("attendee.message") }}</p>
                      </li>
                      <li
                        v-if="OneToOneVideoCallEnabled"
                        :id="attendee.AttendeeKey"
                        :key="attendee.AttendeeKey"
                        @click.stop.once="
                          OpenOneToOneChat(attendee, true);
                          AddEventAnalytics({
                            pageName: '/attendee',
                            action: 'click',
                            actionType: '',
                            actionLabel: 'OneToOneVideoCall: ' + attendee.Name,
                          });
                        "
                      >
                        <v-btn
                          elevation="0"
                          fab
                          dark
                          small
                          :color="
                            attendee.StartingVideoCall ? 'grey' : '#eef1f4'
                          "
                          :loading="attendee.StartingVideoCall"
                          ><img
                            src="../assets/Images/landing/meet-now-network.svg"
                            style="height: 20px; width: 20px"
                        /></v-btn>
                        <p>{{ $t("attendee.meetnow") }}</p>
                      </li>
                      <li
                        v-if="ShowMeetingButton"
                        @click.stop="
                          ScheduleMeeting(attendee);
                          AddEventAnalytics({
                            pageName: '/attendee',
                            action: 'click',
                            actionType: '',
                            actionLabel: 'ScheduleMeeting: ' + attendee.Name,
                          });
                        "
                      >
                        <v-btn elevation="0" fab dark small color="#eef1f4"
                          ><img
                            src="../assets/Images/landing/schedule-network.svg"
                            style="height: 20px; width: 20px"
                        /></v-btn>
                        <p>{{ $t("attendee.schedule") }}</p>
                      </li>
                    </ul>
                  </div>

                  <v-badge
                    v-if="
                      !isAdminComponent &&
                      attendee &&
                      loggedInUseID != attendee.id
                    "
                    color="transparent"
                    bottom
                    class="attendee-box-badge"
                  >
                    <template #badge>
                      <div v-if="!attendee.isBookmarked">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              size="32"
                              color="black"
                              @click.stop="
                                addAttendeeBookMark(
                                  attendee.id,
                                  attendee.Name,
                                  attendee.Image,
                                  attendee.isBookmarked
                                );
                                AddEventAnalytics({
                                  pageName: '/attendee',
                                  action: 'click',
                                  actionType: '',
                                  actionLabel:
                                    'AddNewBookmark: ' + attendee.Name,
                                });
                              "
                              style="cursor: pointer"
                              v-on="on"
                              >bookmark_border</v-icon
                            >
                          </template>
                          <span>Bookmark</span>
                        </v-tooltip>
                      </div>

                      <div v-else>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              size="32"
                              color="success"
                              @click.stop="
                                addAttendeeBookMark(
                                  attendee.id,
                                  attendee.Name,
                                  attendee.Image,
                                  attendee.isBookmarked
                                );
                                AddEventAnalytics({
                                  pageName: '/attendee',
                                  action: 'click',
                                  actionType: '',
                                  actionLabel:
                                    'RemoveBookmark: ' + attendee.Name,
                                });
                              "
                              style="cursor: pointer"
                              >bookmark</v-icon
                            ></template
                          >
                          <span>Bookmarked</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-badge>
                  <div class="left-grid">
                    <div
                      class="attendee-presence-status position-relative"
                      :id="index == 0 ? 'v-step-1' : ''"
                    >
                      <span
                        v-if="showPresence"
                        :class="
                          attendee.isOnline
                            ? 'attendee-status-bubble  attendee-online-status'
                            : 'attendee-status-bubble  attendee-off-online-status'
                        "
                      ></span>
                      <template v-if="attendee.Image">
                        <div
                          class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto"
                          :style="
                            attendee.RegistrationType.ColorCode
                              ? 'border:3px solid ' +
                                attendee.RegistrationType.ColorCode
                              : ''
                          "
                        >
                          <img
                            :src="getCDNUrl(attendee.Image)"
                            @error="attendee.Image = ''"
                            class="imguserthumb"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto"
                          :style="
                            showAttendeeLegend == true &&
                            attendee.RegistrationType.ColorCode
                              ? 'border:3px solid ' +
                                attendee.RegistrationType.ColorCode
                              : ''
                          "
                        >
                          {{ attendee.Initials }}
                        </div>
                      </template>
                    </div>

                    <div class="attendee-des-hld">
                      <h3>
                        {{ attendee.Name }}
                      </h3>
                    </div>
                  </div>
                  <div class="center-grid">
                    <div
                      class="attendee-des-hld pt-0 attendee-technical-details"
                    >
                      <p v-html="attendee.Company"></p>
                      <p v-html="attendee.Title"></p>
                    </div>
                  </div>
                  <div class="right-grid" v-if="isAdminComponent">
                    <div class="attendee-status-switch">
                      <!-- <p v-if="loggedInUseID == attendee.id"><strong>{{attendee.IsPublished?'Published':'Unpublished'}}</strong></p> -->
                      <p v-if="loggedInUseID != attendee.id">
                        <strong>Status</strong>
                      </p>
                      <v-switch
                        v-if="loggedInUseID != attendee.id"
                        color="#1a73e8"
                        v-model="attendee.IsPublished"
                        @click.stop
                        @change="
                          $parent.updateAttendeeData({
                            UserId: attendee.id,
                            IsPublished: attendee.IsPublished,
                          })
                        "
                      ></v-switch>
                    </div>
                    <div class="attendee-edit-dlt d-flex">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            icon
                            class="mr-1"
                            @click.stop="
                              currentAttendee = attendee;
                              editCurrentAttendee();
                            "
                          >
                            <img
                              src="../assets/Images/self-service/edit-self.svg"
                            />
                          </v-btn>
                        </template>
                        <span class="v-tooltip-content v-tooltip-bottom"
                          >Edit Attendee</span
                        >
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if="loggedInUseID != attendee.id"
                            small
                            icon
                            @click.stop="
                              currentAttendee = attendee;
                              showDeleteConfirmDialog = true;
                            "
                          >
                            <img
                              src="../assets/Images/self-service/delete-self.svg"
                            />
                          </v-btn>
                        </template>
                        <span class="v-tooltip-content v-tooltip-bottom"
                          >Delete Attendee</span
                        >
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            icon
                            class="mr-3"
                            @click.stop="
                              currentAttendee = attendee;
                              showPromoteConfirmDialog = true;
                            "
                          >
                            <v-icon size="25px" color="#5a646e"
                              >mdi-account-arrow-up-outline</v-icon
                            >
                          </v-btn>
                        </template>
                        <span class="v-tooltip-content v-tooltip-bottom"
                          >Promote Attendee to Speaker</span
                        >
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <!----attendee box end---->
            </div>
            <!-- No dat Found -->

            <div
              v-show="!IsLoading && IsShowNoDataFound && !isAdminComponent"
              style="text-align: center"
            >
              <h2 style="text-align: center; margin-top: 60px">
                {{
                  attendeeData.length > 0 && searchtext
                    ? "No matches found for your Search"
                    : $t("attendee.nodata")
                }}
              </h2>
            </div>

            <!-- No dat Found ENDS-->

            <div class="show-more-wrap">
              <div
                v-show="
                  !IsLoading && !IsShowNoDataFound && pageCount > pageIndex
                "
                @click="applyFilter"
                class="show-more"
              >
                <img src="../assets/Images/right-arrow-blue1.svg" />
                See more
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!----------right attendee detail-------->
    <!-- Modal -->
    <div
      class="modal right fade attendee-popup-main"
      id="myModal2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body new-addendee-list new-addendee-details p-0">
            <div class="attendee-admin-edit-menu" v-if="isAdminComponent">
              <ul v-if="currentAttendee">
                <li class="final-button small-font">
                  <v-btn
                    v-if="loggedInUseID != currentAttendee.id"
                    color="#000000"
                    text
                    @click="
                      closeModal();
                      showDeleteConfirmDialog = true;
                    "
                    ><v-icon color="#000000" size="20px" class="mr-1"
                      >mdi-trash-can-outline</v-icon
                    >
                    Delete</v-btn
                  >
                </li>

                <li>
                  <div
                    class="admin-attendee-status"
                    v-if="loggedInUseID != currentAttendee.id"
                  >
                    <label>Status</label>
                    <v-switch
                      v-model="currentAttendee.IsPublished"
                      @change="
                        $parent.updateAttendeeData({
                          UserId: currentAttendee.id,
                          IsPublished: currentAttendee.IsPublished,
                        })
                      "
                      color="#1a73e8"
                    ></v-switch>
                  </div>
                </li>
                <li class="small-font">
                  <v-btn
                    @click="editCurrentAttendee()"
                    color="#1a73e8"
                    dark
                    width="152px"
                    height="40px"
                    class="save-standard"
                    ><v-icon
                      color="#ffffff"
                      size="20px"
                      class="mr-1"
                      id="v-step-start"
                      >mdi-pencil-outline</v-icon
                    >
                    Edit Attendee</v-btn
                  >
                </li>
              </ul>
            </div>

            <!------image hld start---->
            <div
              class="attendee-box-hld text-center position-relative pb-2 pt-4"
            >
              <div class="">
                <button
                  type="button"
                  id="btnModalClose"
                  v-on:click="closeModal()"
                  class="close position-relative"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.03"
                    height="18.031"
                    viewBox="0 0 18.03 18.031"
                  >
                    <path
                      id="close.svg"
                      fill="#242432"
                      d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                      transform="translate(-1412 -516)"
                    />
                  </svg>
                </button>
                <v-badge
                  v-show="
                    imageExists &&
                    currentAttendee &&
                    loggedInUseID != currentAttendee.id
                  "
                  color="white"
                  bottom
                  class="attendee-presence-side-popup"
                >
                  <template #badge>
                    <div v-if="!isBookmarked">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            size="32"
                            color="black"
                            @click="addBookMark()"
                            style="cursor: pointer"
                            v-on="on"
                            data-analytics
                            data-page-name="/attendee"
                            data-action="click"
                            :data-action-label="
                              'AddedNewBookmark: ' + currentAttendeeName
                            "
                            >bookmark_border</v-icon
                          >
                        </template>
                        <span>Bookmark</span>
                      </v-tooltip>
                    </div>

                    <div v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            size="32"
                            color="success"
                            data-analytics
                            data-page-name="/attendee"
                            data-action="click"
                            :data-action-label="
                              'RemoveNewBookmark: ' + currentAttendeeName
                            "
                            @click="addBookMark()"
                            style="cursor: pointer"
                            >bookmark</v-icon
                          ></template
                        >
                        <span>Bookmarked</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-badge>

                <v-badge
                  v-show="
                    !imageExists &&
                    currentAttendee &&
                    loggedInUseID != currentAttendee.id
                  "
                  overlap
                  color="white"
                  bottom
                  class="attendee-presence-side-popup"
                >
                  <template #badge>
                    <div v-if="!isBookmarked">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            size="32"
                            color="black"
                            data-analytics
                            data-page-name="/attendee"
                            data-action="click"
                            :data-action-label="
                              'AddedNewBookmark: ' + currentAttendeeName
                            "
                            @click="addBookMark()"
                            style="cursor: pointer"
                            v-on="on"
                            >bookmark_border</v-icon
                          >
                        </template>
                        <span>Bookmark</span>
                      </v-tooltip>
                    </div>

                    <div v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            size="32"
                            color="success"
                            data-analytics
                            data-page-name="/attendee"
                            data-action="click"
                            :data-action-label="
                              'RemoveNewBookmark: ' + currentAttendeeName
                            "
                            @click="addBookMark()"
                            style="cursor: pointer"
                            >bookmark</v-icon
                          ></template
                        >
                        <span>Bookmarked</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-badge>
                <div class="attendee-separate">
                  <div
                    class="attendee-side-popup-presence-indicator position-relative d-inline-block"
                  >
                    <span
                      v-if="currentAttendee && showPresence"
                      :class="
                        currentAttendee.isOnline
                          ? 'attendee-status-bubble  attendee-online-status'
                          : 'attendee-status-bubble  attendee-off-online-status'
                      "
                    ></span>
                    <div
                      id="dvImgeHldText"
                      class="attendee-img-hld mx-auto"
                      v-show="!imageExists"
                    >
                      <img id="imgModalAttendee" class="imguserthumb" />
                    </div>
                    <div
                      v-show="imageExists"
                      id="dvImgeHld"
                      class="attendee-img-hld mx-auto"
                      data-toggle="modal"
                      data-target="#modalZoomImage"
                    >
                      <img
                        v-if="currentAttendee && currentAttendee.Image"
                        id="imgModalAttendee"
                        :src="currentAttendee.Image"
                        class="imguserthumb"
                      />
                    </div>
                  </div>
                  <div class="attendee-details-sticky-right">
                    <div class="attendee-des-hld">
                      <input type="hidden" id="hdnAttendeeId" />
                      <h3 id="modalName"></h3>
                      <p id="modalCompany"></p>
                      <p id="modalTtile"></p>
                    </div>
                    <!--------social----->
                    <div class="social-icon d-flex justify-content-center">
                      <a
                        id="anchFacebook"
                        data-tag="Facebook"
                        v-on:click="onClickHandler"
                        href="#"
                        target="_blank"
                      >
                        <span id="spnFacebook">
                          <i
                            class="fa fa-facebook"
                            id="iFacebook"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </a>
                      <a
                        id="anchTwitter"
                        data-tag="Twitter"
                        v-on:click="onClickHandler"
                        href="#"
                        target="_blank"
                      >
                        <span id="spnTwitter">
                          <i
                            class="fa fa-twitter"
                            id="iTwitter"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </a>
                      <a
                        id="anchLinkedIn"
                        data-tag="LinkedIn"
                        v-on:click="onClickHandler"
                        href="#"
                        target="_blank"
                      >
                        <span id="spnLinkedIn">
                          <i
                            class="fa fa-linkedin"
                            id="iLinkedIn"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <!--------social----->
                <!--button area start--->
                <div
                  id="divRequestWrap"
                  class="button-area-hld text-center btn-theme"
                >
                  <button
                    id="btnOpenRequestMeeting"
                    @click="OpenRequestMeeting"
                    v-on:click="onClickHandler"
                    data-target="#calendarModal"
                    data-toggle="modal"
                    v-show="ShowMeetingButton"
                    class="btn request-meeting mt-1 border-stranprent border-tranprent"
                  >
                    {{ $t("attendee.requestmeeting") }}
                  </button>
                  <a
                    id="btnShowSendMessageButton"
                    v-if="ShowSendMessageButton && currentAttendee"
                    @click="
                      onClickHandler($event);
                      hasValidAuth({ auth_type: 1 });
                    "
                    :href="
                      hasValidAuth({ auth_type: 1, no_need_reg_login: true })
                        ? 'mailto:' + currentAttendee.Email
                        : 'javascript:void(0);'
                    "
                    :target="
                      hasValidAuth({ auth_type: 1, no_need_reg_login: true })
                        ? '_blank'
                        : ''
                    "
                    :data-tag="
                      'Attendee -' + currentAttendee.Name + '- SendMessage'
                    "
                    class="btn send-message ml-md-2 mt-1 request-meeting"
                    style="color: #ffffff !important"
                  >
                    {{ $t("attendee.sendmessage") }}
                  </a>
                </div>
              </div>
              <!---button area end-->
              <hr />
              <!-------contact details---->
              <div class="contact-details">
                <ul class="p-0 m-0" id="ulContact">
                  <li
                    id="modalEmail"
                    v-on:click="onClickHandler"
                    v-show="ShowEmailandPhone"
                    class="email"
                  ></li>
                  <li
                    id="modalPhone"
                    v-on:click="onClickHandler"
                    v-show="ShowEmailandPhone"
                    class="ph-no"
                  ></li>
                  <li id="modalWebsite" class="website">
                    <a
                      id="anchmodalWebsite"
                      v-on:click="onClickHandler"
                      href="#"
                      target="_blank"
                    ></a>
                  </li>
                  <li id="modalRegistrationType" class="text-justify deg"></li>
                </ul>
              </div>
              <!-------contact details---->
              <hr v-show="ShowEmailandPhone" />
              <div class="attendee-details-lower-section">
                <!-------attendee description start--->
                <div id="modalProfile" class="text-justify"></div>
                <!-------attendee description end--->
                <!-------attendee dynamic content start--->
                <div
                  id="divDynamicContent"
                  class="text-justify"
                  v-show="showDynamicFieldsSettings"
                >
                  <!-- <div class="card">
                    <h5>Other Info</h5>
                  </div> -->
                </div>
                <!-------attendee dynamic content ends--->
                <!-- ---------------- Exchange Businesscard popuop ----------------- -->
                <div class="attendees-exhangecard-button d-none">
                  <v-dialog transition="dialog-top-transition" max-width="1000">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="#2376e5"
                        class="white--text exchange-vcard"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <span class="mr-4"
                          ><img
                            src="../assets/Images/icons/exchange-business-card.svg"
                        /></span>
                        Exchange Business Card
                      </v-btn>
                    </template>
                    <template v-slot:default="dialog">
                      <v-card class="p-4" color="#f4f7f9">
                        <div class="attendee-bznscard-wrap position-relative">
                          <div class="pop-close-button">
                            <span @click="dialog.value = false"
                              ><v-icon color="blue-grey darken-2"
                                >mdi-close</v-icon
                              ></span
                            >
                          </div>
                          <v-row>
                            <v-col cols="12" md="4" sm="12">
                              <div class="attendee-bzns-details">
                                <div class="bzns-attendee-img">
                                  <img
                                    src="../assets/Images/avatar.jpg"
                                    alt="Attendee-Images"
                                  />
                                  <span class="d-none bzns-name-initial"
                                    >FS</span
                                  >
                                </div>
                                <div class="bzns-attendee-intro">
                                  <h3>Franklyn Sneed</h3>
                                  <h4>Omni Tech Solutions</h4>
                                </div>
                                <div class="bzns-contact">
                                  <ul>
                                    <li>alissa.berglund@switzerland.com</li>
                                    <li>Attendee</li>
                                  </ul>
                                </div>
                                <div class="bzns-attendee-description">
                                  <p>
                                    Lorem Ipsum is simply dummy text of the
                                    printing and typesetting industry. Lorem
                                    Ipsum has been the industry's standard dummy
                                    text ever since the 1500s, when an unknown
                                    printer took a galley of type and scrambled
                                    it to make a type specimen book. It has
                                    survived not only five centuries, but also
                                    the leap into electronic typesetting,
                                    remaining essentially unchanged.
                                  </p>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="12" md="8" sm="12">
                              <div class="attendee-bzns-card">
                                <!-- <div class="bzns-card-qr-holder">
                                    <img src="../assets/Images/bznscard-qr-code.jpg"/>
                                  </div>
                                  <h4 class="mt-3">Scan QR to Save on Phone</h4>
                                  <h4 class="mb-3">or</h4>
                                  <v-btn large color="#2376e5" class="ma-2 white--text">
                                    <span class="mr-4"><img src="../assets/Images/icons/email-vcard-white.svg"/></span>
                                    EMAIL V-CARD
                                  </v-btn> -->
                                <div class="bznscard-exchange-success">
                                  <img
                                    src="../assets/Images/icons/vcard-exchange-success.svg"
                                  />
                                </div>
                                <h3 class="mt-3">Success!</h3>
                                <h5 class="mb-3">
                                  The business card has been sent to your mail
                                </h5>
                                <v-btn
                                  large
                                  color="#2376e5"
                                  class="ma-2 white--text"
                                >
                                  VIEW SAVED BUSINESS CARD
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card>
                    </template>
                  </v-dialog>
                </div>
              </div>
              <!-- ---------------- Exchange Businesscard popuop ----------------- -->
            </div>

            <!------image hld end---->
          </div>
        </div>
        <!-- modal-content -->
      </div>
      <!-- modal-dialog -->
    </div>
    <!-- modal -->
    <!---------profile image zoom------------->
    <div
      class="modal fade profile-zoom-effect"
      id="modalZoomImage"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            data-supported-dps="24x24"
            fill="#ffffff"
            width="24"
            height="24"
            focusable="false"
          >
            <path
              d="M20 5.32L13.32 12 20 18.68 18.66 20 12 13.33 5.34 20 4 18.68 10.68 12 4 5.32 5.32 4 12 10.69 18.68 4z"
            />
          </svg>
        </button>
      </div>
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-zoom modal-lg"
        role="document"
      >
        <div class="modal-content align-items-center justify-content-center">
          <div class="modal-body">
            <div class="big-img-wrapper">
              <img
                id="imgModalAttendeeEnlarge"
                src="../assets/Images/new-attendee-img.jpg"
                class="imguserthumb"
              />
              <!-- PH -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---------------------->
    <!----------Start RequestMeeting popup-------->
    <RequestMeeting
      :key="requestMeetingKey"
      :attendee="currentAttendee"
      :DynamicFieldsExcludeOptions="DynamicFieldsExcludeOptions"
      :StaticFieldsExcludeOptions="StaticFieldsExcludeOptions"
    ></RequestMeeting>

    <!----------Start RequestMeeting popup-------->

    <!----------right attendee detail-------->
    <!-- <div id="dvBackDrop" class="modal-backdrop fade" style="display:none;"></div> -->

    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <div class="loader">
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <div class="custom-v-tour">
      <v-tour
        name="attendeeListTour"
        :steps="steps"
        :options="tourOptions"
        :callbacks="tourCallbacks"
      ></v-tour>
    </div>

    <v-dialog v-model="showDeleteConfirmDialog" max-width="500px" hide-overlay>
      <v-card>
        <v-card-title>
          <div
            class="restore-default-head d-flex justify-content-end align-items-start"
          >
            <v-btn
              text
              fab
              color="#1c1d26"
              height="30px"
              width="30px"
              @click="showDeleteConfirmDialog = false"
              ><v-icon color="#1c1d26" size="25px">mdi-close</v-icon></v-btn
            >
          </div>
          <div
            class="confirmation-option-button pb-10 final-button d-flex justify-content-center align-items-center flex-column"
          >
            <h5>Are you sure you want to delete this attendee?</h5>
            <div class="mt-5">
              <v-btn
                dark
                large
                color="#1c1d26"
                width="120px"
                class="mr-2"
                @click="deleteAttendee(currentAttendee, 1)"
                >Yes</v-btn
              >
              <v-btn
                large
                color="#1c1d26"
                outlined
                width="120px"
                @click="deleteAttendee(currentAttendee, 2)"
                >No</v-btn
              >
            </div>
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPromoteConfirmDialog" max-width="500px" hide-overlay>
      <v-card>
        <v-card-title>
          <div
            class="restore-default-head d-flex justify-content-end align-items-start"
          >
            <v-btn
              text
              fab
              color="#1c1d26"
              height="30px"
              width="30px"
              @click="showPromoteConfirmDialog = false"
              ><v-icon color="#1c1d26" size="25px">mdi-close</v-icon></v-btn
            >
          </div>
          <div
            class="confirmation-option-button pb-10 final-button d-flex justify-content-center align-items-center flex-column"
          >
            <h5>Do you want to promote this attendee to speaker?</h5>
            <div class="mt-5">
              <v-btn
                dark
                large
                color="#1c1d26"
                width="120px"
                class="mr-2"
                @click="promoteAttendee(currentAttendee, 1)"
                >Yes</v-btn
              >
              <v-btn
                large
                color="#1c1d26"
                outlined
                width="120px"
                @click="promoteAttendee(currentAttendee, 2)"
                >No</v-btn
              >
            </div>
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.custom-filter-right {
  position: absolute;
  z-index: 99;
  background: #fff;
  top: 100%;
  min-width: 300px;
  max-width: 350px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  border-radius: 0;
  margin-top: 5px;
  margin-left: 9px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}
.custom-filter-right .checkbox-hld span {
  flex: 18px 0 0;
}

.custom-filter-right {
  scrollbar-color: #888 #333;
  scrollbar-width: thin;
}

.custom-filter-right::-webkit-scrollbar {
  width: 0px;
}

.custom-filter-right::-webkit-scrollbar-track {
  background: #333;
}

.custom-filter-right::-webkit-scrollbar-thumb {
  background: #888;
}

.custom-filter-right::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.custom-filter-right .clear-filter {
  text-align: right;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d3d6db;
  padding-bottom: 8px;
  position: relative;
}
span.close-btn-filter {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-73%);
  cursor: pointer;
}
.custom-filter-right .clear-filter .filter-header {
  font-size: 20px;
  font-weight: 600;
}
.custom-filter-right .clear-filter .clear-btn {
  cursor: pointer;
  color: #3c4852;
  background-color: #f1f4f6;
  font-weight: normal;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
}
.custom-radios input[type="checkbox"] + label span img {
  opacity: 0;
  transition: all 0.3s ease;
  width: 10px;
}
.custom-radios input[type="checkbox"]:checked + label span {
  background-color: #000000;
  border-color: #000000;
}
.custom-radios input[type="checkbox"]:checked + label span img {
  opacity: 1;
}
.custom-radios input[type="checkbox"] {
  display: none;
  position: inherit;
}

[type="checkbox"]:checked,
[type="checkbox"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

input[type="checkbox"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
}

.custom-radios input[type="checkbox"] + label {
  color: #242432;
  padding: 0;
  display: flex;
  align-items: center;
}

[type="checkbox"]:checked + label,
[type="checkbox"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
.custom-radios input[type="checkbox"] + label span {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: -1px 12px 0 0;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid #d3d6db;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-filter-right .language-box {
  max-height: 300px;
  overflow-y: auto;
}

.custom-filter-right .language-box {
  scrollbar-color: #888 #333;
  scrollbar-width: thin;
}

.custom-filter-right .language-box::-webkit-scrollbar {
  width: 6px;
}

.custom-filter-right .language-box::-webkit-scrollbar-track {
  background: #333;
}

.custom-filter-right .language-box::-webkit-scrollbar-thumb {
  background: #888;
}

.custom-filter-right .language-box::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.select-box {
  padding: 5px 0;
}
.custom-radios .checkbox-hld {
  padding: 5px 0;
}
.select-box .filter-group {
  font-weight: 500;
  font-size: 16px;
  position: relative;
  /*margin-bottom: 30px;*/
  margin: 5px 0;
  cursor: pointer;
}
.select-box .filter-group[aria-expanded="true"]:after {
  transform: translateY(-50%) rotate(180deg);
  transition: 0.2s;
}

.select-box .filter-group:after {
  position: absolute;
  background-image: url("../assets/Images/arrow-icon.svg");
  content: "";
  right: 0;
  left: auto;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
  width: 14px;
  height: 14px;
  transition: 0.2s;
}
.filter-group .badge {
  padding: 3px 0 1px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  position: absolute;
  top: -9px;
  /*right: -8px;*/
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  background-color: #ccc;
  border: 2px solid transparent;
  width: 20px;
  height: 20px;
  box-shadow: 0px 8px 10px -10px rgb(10 10 10 / 33%),
    3px -1px 20px -10px rgb(10 10 10 / 33%);
  text-align: center;
  color: white;
  font-size: 12px;
}

.edit-panel-cvr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 12px 0 12px 0;
}

.legend-attendee {
  width: 14px;
  height: 14px;
  z-index: 2;
  background: #f2f2f2;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  margin: 0;
  margin-right: 8px;
}
.attendee-legend-list {
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 0px;
  border: 1px solid transparent;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
}
.attendee-legend-list.selected {
  /*background: #d3d3d3;*/
  background: #feefc3;
  border: 1px solid #878e88;
  padding: 2px 5px;
  cursor: unset;
}
.attendee-legend-list.selected label {
  border: 1px solid #878e88;
}
.attendee-filter-btn {
  position: relative;
}
.attendee-filter-btn.has-filter::after {
  content: "";
  position: absolute;
  height: 10px;
  width: 10px;
  background: orangered;
  border: 2px solid orangered;
  border-radius: 50%;
  right: 5px;
  top: 10px;
}

.show-more-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
}
.show-more {
  width: 200px;
  border: 1px solid #288aef;
  border-radius: 20px;
  background-color: #fff;
  text-align: center;
  padding: 5px 20px;
  font-size: 16px;
  color: #4285f4;
  cursor: pointer !important;
  position: relative;
  font-weight: 400;
}
.show-more img {
  margin-top: 2px;
  position: absolute;
  left: 16px;
}
.attendees-exhangecard-button {
  position: absolute;
  width: 88%;
  text-align: center;
  left: 0;
  margin: 0 7%;
  bottom: 25px;
}
.exchange-vcard {
  height: 45px !important;
}
.exchange-vcard span {
  font-size: 15px !important;
  letter-spacing: 1px !important;
}
.attendee-bzns-details {
  min-height: 600px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  padding: 20px;
  border-radius: 12px;
}
.bzns-attendee-img {
  height: 130px;
  width: 130px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 50%;
  background: #b0b2b4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bzns-attendee-intro {
  width: 100%;
  text-align: center;
  margin: 8px 0;
}
.bzns-attendee-intro h3 {
  font-size: 24px;
  font-weight: 600;
  color: #1c1d26;
  margin: 0;
}
.bzns-attendee-intro h4 {
  font-weight: 400;
  font-size: 18px;
  color: #1c1d26;
}
.bzns-contact {
  margin: 30px 0;
  padding: 15px 0;
  border-top: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
}
.bzns-contact ul {
  margin: 0;
  padding: 0;
}
.bzns-contact ul li {
  list-style: none;
  display: block;
  padding-left: 22px;
  margin-bottom: 15px;
  font-size: 16px;
  color: #505456;
}
.bzns-contact ul li:last-child {
  margin-bottom: 0;
  background: url(../assets/Images/icons/attende-bzns-desc.svg) no-repeat left
    center / 16px;
}
.bzns-contact ul li:first-child {
  background: url(../assets/Images/icons/email-vcard.svg) no-repeat left center /
    16px;
}
.bzns-attendee-description p {
  font-size: 15px;
  font-weight: 400;
  color: #000;
  margin: 0;
}
.pop-close-button {
  position: absolute;
  top: 0px;
  right: -12px;
  cursor: pointer;
  z-index: 999;
}
.bzns-card-qr-holder {
  height: 250px;
  width: 250px;
  background: url(../assets/Images/qr-holder.png) no-repeat center center / 100%;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.bzns-card-qr-holder img {
  height: 100%;
  width: 100%;
}
.attendee-bzns-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.attendee-bzns-card h4 {
  color: #000;
  font-size: 24px;
  font-weight: 600;
}
span.bzns-name-initial {
  margin: 0;
  font-size: 70px;
  font-weight: 600;
  color: #fff;
  text-shadow: 1px 1px 2px #000, 0 0 1em #fff, 0 0 0.2em #fff;
}
.attendee-bzns-card h3 {
  color: #000;
  font-weight: 600;
  font-size: 30px;
}
.attendee-bzns-card h5 {
  color: #000;
  font-weight: 400;
  font-size: 20px;
  width: 300px;
  text-align: center;
}
/*--------------------Mobile---------------------*/
@media only screen and (max-width: 767px) {
  .custom-filter-right {
    left: 0;
    z-index: 9;
  }
  .pop-close-button {
    position: absolute;
    top: -7px;
    right: -17px;
    cursor: pointer;
    z-index: 999;
  }
}
</style>
<style>
.custom-v-tour .v-step__header {
  background: #19191d !important;
  color: #fff !important;
  position: relative !important;
}
.custom-v-tour .v-step {
  background: #19191d !important;
  color: #dfdfdf !important;
  font-size: 16px !important;
  border: 1px solid #b5b5b5 !important;
  padding: 25px 30px;
}

.custom-v-tour .v-step__header:after {
  content: "";
  position: absolute;
  width: 95%;
  height: 1px;
  background: #2a2a2f;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.custom-v-tour .v-step__button.v-step__button-skip,
.custom-v-tour .v-step__button.v-step__button-previous {
  border: none !important;
  background: #393a3e !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}

.custom-v-tour .v-step .v-step__arrow {
  border-color: #b5b5b5 !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.custom-v-tour .v-step__button.v-step__button-next,
.custom-v-tour .v-step__button.v-step__button-stop {
  border: none !important;
  background: #2376e5 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}

.attendee-box-badge {
  position: absolute;
  top: 4px;
  right: 45px;
}

.attendee-presence-side-popup {
  position: absolute;
  left: 20px;
  top: 12px;
}
.attendee-box-hld .v-badge__badge {
  display: none !important;
}
.attendee-box-hld:hover .v-badge__badge {
  display: block !important;
}
</style>
<script>
import Vue from "vue";
import db from "../components/firebaseInit";
//import AttendeeDetails from "@/components/AttendeeDetails.vue";
import jQuery from "jquery";
let $ = jQuery;
import analytics from "@/components/Analytics";
//import router from "../router";
import axios from "axios";
import APIs from "@/components/APIInit";
import moment from "moment";
//import store from "../store";
import RequestMeeting from "@/components/RequestMeeting.vue";
import common from "@/common";
import { bus } from "@/main";
import VueTour from "vue-tour";
//import EventListReg2Vue from './EventListReg2.vue';
require("vue-tour/dist/vue-tour.css");

let lastVisible = null;
let hasMore = true;
var self;
let interval;
Vue.use(VueTour);
// $(document).mouseup(function (e) {
//     var popup = $(".bubble-head-presence-details");
//     if (!$('.attendee-presence').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
//         popup.hide();
//     }

// });
export default {
  components: {
    RequestMeeting,
  },
  props: {
    isAdminComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDynamicFieldsSettings: false,
      showPresence: false,
      toggle: false,
      StartingVideoCallId: false,
      showDeleteConfirmDialog: false,
      showPromoteConfirmDialog: false,
      activeUsersInsideEvent: [],
      switch70: true,
      switch71: true,
      switch18: true,
      imageExists: null,
      isBookmarked: false,
      currentAttendee: null,
      attendeeEvent: null,
      ShowEmailandPhone: false,
      EnableAttendeeDBsearch: false,
      headerText: this.$t("attendee.attendees"),
      ShowMeetingButton: false,
      ShowSendMessageButton: false,
      ShowFilter: false,
      ShowSearch: false,
      AttendeeSettingsLoaded: false,
      OneToOneChatEnabled: false,
      OneToOneVideoCallEnabled: false,
      loggedInUseID: "",
      pageSize: 500,
      pageIndex: 0,
      pageCount: 1,
      totalRecords: 1,
      lastVisible: null,
      attendeeData: [],
      speakersList: [],
      ShowSpeakerInAttendee: true,
      searchtext: "",
      IsShowNoDataFound: false,
      IsLoading: true,
      IsShowCancelButton: false,
      IsSearchMode: false,
      GlobalKeysData: {
        IsBroadcastInNewTab: 1,
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
      clientID: this.$store.getters.getClient[0].id,
      eventId: null,
      eventcollection: "",
      textColor: "black",
      //SlotAvailable: [],
      APIs: APIs,
      AttendeeListSortBy: "Name",
      AttendeeListSorDirection: "asc",
      filterDisplayState: false,
      DynamicFilterOptions: [],
      DynamicFieldsExcludeOptions: [],
      StaticFieldsExcludeOptions: {},
      hasFilterOrSearch: false,
      regTypes: [],
      showAttendeeLegend: false,
      ShowFilterQuery: false,
      ShowSearchQuery: false,
      requestMeetingKey: 0,
      meetingRestrictionEnabled: false,
      restrictedRegistrationTypes: [],
      restrictedAttendeeIDs: [],
      ExcludeCountriesFromFilter: [],
      myRegistrationType: "",
      isScrolled: false,
      currentAttendeeName: "",
      selectedLegendRegType: "All",
      steps: [
        {
          target: "#v-step-1",
          header: {
            title: "View Attendees:",
          },
          content: "Review Attendees and edit them",
          params: {
            placement: "bottom",
            positionFixed: true,
          },
        },
        {
          target: "#v-step-2",
          header: {
            title: "Advanced Settings 1:",
          },
          content: "Advanced settings for nerds! :)",
          params: {
            placement: "bottom",
            positionFixed: true,
          },
        },
      ],

      tourOptions: {
        labels: {
          buttonSkip: "Skip",
          buttonPrevious: "Previous",
          buttonNext: "Next",
        },
      },
      tourCallbacks: {
        onNextStep: this.onTourNext,
      },
    };
  },
  computed: {
    MeetingSettings() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return {
        Slot:
          obj.MeetingSettings[0] != undefined
            ? obj.MeetingSettings[0].Slot
            : [],
        StartDate:
          obj.MeetingSettings[0] != undefined
            ? obj.MeetingSettings[0].StartDate
            : "",
        EndDate:
          obj.MeetingSettings[0] != undefined
            ? obj.MeetingSettings[0].EndDate
            : "",
        AvailabilityFromTime:
          obj.MeetingSettings[0] != undefined
            ? obj.MeetingSettings[0].AvailabilityFromTime
            : "",
        AvailabilityToTime:
          obj.MeetingSettings[0] != undefined
            ? obj.MeetingSettings[0].AvailabilityToTime
            : "",
        Duration:
          obj.MeetingSettings[0] != undefined
            ? obj.MeetingSettings[0].Duration
            : "",
      };
    },
    hasFilter() {
      let result = 0;
      self.DynamicFilterOptions.forEach(function (item) {
        if (item.badge > 0) {
          result++;
        }
      });
      //result = 1;
      return result > 0;
    },
    finalAttendeeList() {
      let attendeeList = [];
      //let searchText = self.searchtext.trim().toLowerCase();
      self.attendeeData.forEach(function (objAttendee) {
        //if (
        //  objAttendee.Name == undefined ||
        //  objAttendee.Company == undefined ||
        //  objAttendee.Designation == undefined ||
        //  objAttendee.Tags == undefined
        //) {
        //  alert("undefined");
        //}
        //if (objAttendee.id == "51024") {
        //  //alert(objAttendee.IsPublished);
        //}

        let flag = true;
        //if (!objAttendee.IsPublished) {
        //  flag = false;
        //} else
        //if (objAttendee.HideInList) {
        //  flag = false;
        //} else

        // if (!self.ShowSpeakerInAttendee) {
        //   if (self.speakersList.includes(objAttendee.id)) {
        //     flag = false;
        //   }
        // }

        //if (objAttendee.IsPublished && !objAttendee.HideInList) {
        //  if (self.ShowSpeakerInAttendee) {
        //    flag = true;
        //  } else {
        //    if (self.speakersList.indexOf(objAttendee.AttendeeId) < 0) {
        //      flag = true;
        //    }
        //  }
        //}

        if (flag) {
          //let name = objAttendee.Name
          //  ? objAttendee.Name.trim().toLowerCase()
          //  : "";
          //let company = objAttendee.Company
          //  ? objAttendee.Company.trim().toLowerCase()
          //  : "";
          //let designation = objAttendee.Designation
          //  ? objAttendee.Designation.trim().toLowerCase()
          //  : "";
          //let tags = objAttendee.Tags;
          //if (tags && typeof objAttendee.Tags != "string") {
          //  tags = "";
          //}
          //tags = tags ? tags.trim().toLowerCase() : "";
          //if (
          //  searchText == "" ||
          //  name.includes(searchText) ||
          //  company.includes(searchText) ||
          //  designation.includes(searchText) ||
          //  tags.includes(searchText)
          //) {
          attendeeList.push(objAttendee);
          //}
        }
      });
      if (attendeeList.length > 0) {
        self.IsShowNoDataFound = false;
      } else {
        self.IsShowNoDataFound = true;
      }
      return attendeeList;
      //return self.attendeeData;
    },
    //displayDynamicField(fieldId) {
    //  let flag = false;
    //  let fields = self.DynamicFieldsExcludeOptions.filter(function (item) {
    //    return item == fieldId;
    //  });
    //  if (fields.length > 0) {
    //    flag = true;
    //  }
    //  return flag;
    //},
  },
  watch: {
    "$route.query": function (val) {
      if (val.sid) {
        let attendeeList = this.finalAttendeeList;
        let attendee = attendeeList.find((atnd) => atnd.id == val.sid);
        this.$nextTick(() => {
          setTimeout(() => {
            console.log(attendee);

            this.openModal(
              attendee.id,
              attendee.Name,
              attendee.Company,
              attendee.Title,
              attendee.Image,
              attendee.Email,
              attendee.Phone,
              attendee.Website,
              attendee.Profile,
              attendee.SocialLinks,
              attendee.Initials,
              attendee.RegistrationType,
              attendee.DynamicFields,
              attendee
            );
            $("#myModal2").modal("show");
            this.$router.replace({ params: {}, query: {} });
          }, 50);
        });
      }
    },
    attendeeEvent(val) {
      if (val) {
        this.$store.commit("addEventCollection", val.iceId);
        this.$store.commit("addEventID", val.EventId);
        self.IsSearchMode = true;
        this.getAttendeeDetails();
      }
    },
    AttendeeSettingsLoaded(val) {
      if (val) {
        self.applyFilter();
      }
    },
    searchtext(val) {
      if (!val) {
        self.searchAttendee();
      }
    },
    activeUsersInsideEvent() {
      self.attendeeData.map((attendee) => {
        attendee.isOnline = self.getAttendeeLoggedInStatus(attendee.id);
      });
    },
  },
  created() {
    self = this;
    var obj = JSON.parse(window.localStorage.getItem("my-app"));

    if (obj && obj.user && obj.user.length > 0) {
      self.loggedInUseID = obj.user[0].id;
    }
    if (obj && obj.eventcollectionname) {
      self.eventcollection = obj.eventcollectionname;

      self.speakersList = [];
      var lstSpkRef = db
        .collection(self.eventcollection)
        .doc("SpeakerList")
        .collection("Speakers");
      lstSpkRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //if (speakersList2.indexOf(doc.data().AttendeeId) < 0) {
          self.speakersList.push(doc.data().SpeakerId);
          //}
        });
      });

      var refSpkSettings = db
        .collection(self.eventcollection)
        .doc("Settings")
        .collection("Speaker")
        .doc("SpeakerSettings");

      refSpkSettings.get().then(function (doc) {
        if (doc.exists) {
          self.ShowSpeakerInAttendee = doc.data().ShowInAttendee;
        }
      });

      db.collection(self.eventcollection)
        .doc("Settings")
        .collection("Attendee")
        .doc("AttendeeSettings")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.showAttendeeLegend = doc.data().ShowLegend == true;
            self.EnableAttendeeDBsearch =
              doc.data().EnableAttendeeDBsearch == true;

            self.showDynamicFieldsSettings =
              doc.data().ShowDynamicFields == true;

            self.showPresence = doc.data().ShowPresence == true;

            self.ShowMeetingButton = doc.data().ShowMeetingButton == true;
            self.ShowSendMessageButton =
              doc.data().ShowSendMessageButton == true;
            self.ShowFilter = doc.data().ShowFilter == true;
            self.ShowSearch = doc.data().ShowSearch == true;

            self.ShowEmailandPhone = doc.data().ShowEmailandPhone == true;
            self.AttendeeListSortBy = doc.data().AttendeeListSortBy == true;
          }
          self.AttendeeSettingsLoaded = true;
        })
        .catch(function (error) {
          self.AttendeeSettingsLoaded = true;
          console.log("Error : " + error);
        });

      db.collection(self.eventcollection)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(self.loggedInUseID)
        .get()
        .then((doc) => {
          if (doc.exists) {
            var attendee = doc.data();
            if (typeof attendee.RegistrationType == "string") {
              self.myRegistrationType = attendee.RegistrationType;
            } else if (typeof attendee.RegistrationType == "object") {
              self.myRegistrationType =
                attendee.RegistrationType.RegistrationType;
            }
          }
        });
    }

    bus.$on("activeUsersList", (data) => {
      self.activeUsersInsideEvent = data;
    });
    self.GetPluginSettings();
  },
  beforeDestroy() {
    //window.removeEventListener("scroll", this.onScrollHandler);
    hasMore = true;
    lastVisible = null;
    self.attendeeData = [];
    self.searchtext = "";
  },
  beforeUpdate() {
    //alert("beforeUpdate");
    //self.attendeeData.sort(function(a, b) {
    //  let aName = a[self.AttendeeListSortBy].trim().toLowerCase();
    //  let bName = b[self.AttendeeListSortBy].trim().toLowerCase();
    //  if (aName < bName) {
    //    return -1;
    //  }
    //  if (aName > bName) {
    //    return 1;
    //  }
    //  return 0;
    //});
  },
  async mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };
    //self.UpdateAttendeeMeeting();
    bus.$emit("setUserWelcomeLoader", data);
    this.getAttendeeDetails();
    //document.body.addEventListener("scroll", this.scroll);

    //Do not Delete These Method Calls
    //self.createDynamicFieldFilterOptions();
    //self.createDynamicFieldDisplayOptions();
    bus.$on("start-attendee-tour", (flag) => {
      if (flag) {
        if (self.isAdminComponent) {
          self.$tours["attendeeListTour"].start();
        }
      }
    });
    //await self.getDuplicateAttendees();
  },

  methods: {
    UpdateAttendeeMeeting() {
      // 99914779
      // 99928577
      // 99928578
      // 99928580
      // 99928581
      // 99928583
      // 99928584
      // 99928585
      // 99928590
      // 99928591
      // 99928597
      // 99928598
      // 99928599
      // 99928600
      // 99928603
      // 99928607
      // 99928619
      // 99928623
      // 99928624
      // 99928643
      // 99928661
      // 99928670
      // 99928671
      // 99928691
      // 99928692
      // 99928703
      // 99928705
      // 99928706
      // 99928707
      // 99928708
      setTimeout(() => {
        var disputeAttendees = [];
        db.collection(self.eventcollection)
          .doc("AttendeeList")
          .collection("Attendees")
          //.where("AttendeeId", "==", "99928708")
          .get()
          .then(async (queryAttendees) => {
            debugger;
            queryAttendees.forEach(async (attendeeDoc) => {
              var attendeeData = attendeeDoc.data();
              if (attendeeData.Slots) {
                var attendeeId = attendeeData.AttendeeId;
                var attendeeSlots = attendeeData.Slots;

                var meetingSlots = [];
                var meetingIDs = [];
                db.collection(self.eventcollection)
                  .doc("MeetingList")
                  .collection("Meetings")
                  .where("Invitee.AttendeeId", "==", attendeeId)
                  .get()
                  .then(async (query) => {
                    debugger;
                    query.forEach(async (doc) => {
                      var data = doc.data();
                      if (
                        data.Status != "Rejected" &&
                        data.Status != "Canceled" &&
                        data.Status != "Pending"
                      ) {
                        meetingSlots.push(data.Slots[0]);
                        meetingIDs.push(data.MeetingId);
                      }
                      // console.log(data);
                    });
                    db.collection(self.eventcollection)
                      .doc("MeetingList")
                      .collection("Meetings")
                      .where("Requestor.AttendeeId", "==", attendeeId)
                      .get()
                      .then(async (query) => {
                        debugger;
                        query.forEach(async (doc1) => {
                          var data1 = doc1.data();
                          if (
                            data1.Status != "Canceled" &&
                            data1.Status != "Rejected"
                          ) {
                            meetingSlots.push(data1.Slots[0]);
                            meetingIDs.push(data1.MeetingId);
                          }
                          // console.log(data1);
                        });
                        //console.log(meetingSlots);

                        var deletedMSlots = [];
                        attendeeSlots.forEach((slot) => {
                          // console.log(data1);
                          if (!meetingSlots.includes(slot)) {
                            deletedMSlots.push(slot);
                          }
                        });
                        //console.log(meetingSlots);
                        if (deletedMSlots.length > 0) {
                          //alert(attendeeId+":"+deletedMSlots.length);
                          console.log(
                            attendeeId +
                              ":>>>>>>>>>>>>>>>>" +
                              deletedMSlots.length
                          );
                          disputeAttendees.push(attendeeId);

                          // db.collection(self.eventcollection)
                          //   .doc("AttendeeList")
                          //   .collection("Attendees")
                          //   .doc(attendeeId)
                          //   .update({ Slots: meetingSlots, Meetings: meetingIDs})
                          //   .then(async () => {
                          //     alert("Success");
                          //   })
                          //   .catch(function (error) {
                          //     console.log("Error : " + error);
                          //   });
                        }
                      })
                      .catch(function (error) {
                        console.log("Error : " + error);
                      });
                  })
                  .catch(function (error) {
                    console.log("Error : " + error);
                  });
              }
            });

            // console.log(
            //   "disputeAttendees :>>>>>>>>> " + disputeAttendees.length
            // );
          })
          .catch(function (error) {
            console.log("Error : " + error);
          });
      }, 1000);
    },
    async getDuplicateAttendees() {
      await db
        .collection(self.eventcollection)
        .doc("AttendeeList")
        .collection("Attendees")
        .get()
        .then(async (query) => {
          var attendeeList = [];
          let headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };
          let requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: self.getClientId(),
              eventId: self.getEventId(),
            },
            data: {
              userId: 0,
            },
          };
          await query.forEach(async (doc) => {
            var data = doc.data();
            //if (data.Email == "debashis.giri@webspiders.com") {
            //debugger;
            //alert(data.Email);
            requestData.data.userId = data.AttendeeId;

            var result = await axios.post(APIs.GetJoinURL, requestData, {
              headers: headers,
            });
            // .then((response) => {
            //   console.log(response);
            //   //vm.ManageMenuUpdating = false;
            //   if (response && response.data && response.data.status == 0) {
            //     // let attendee = {AttendeeId:}
            //     alert(response.data.joinURL);
            //   } else {
            //     //vm.showSnackbar("Menu updated failed!", "error", "top");
            //   }
            // })
            // .catch((error) => {
            //   //vm.ManageMenuUpdating = false;
            //   debugger;
            //   //alert("SaveManageMenu Failure");
            //   console.log("onSpeakerSelected: " + error);
            //   //vm.showSnackbar("Menu updated failed!", "error", "top");
            // });
            //debugger;
            if (result && result.data && result.data.status == 0) {
              //let attendee = {AttendeeId:}
              //alert(result.data.joinURL);
              attendeeList.push({
                AttendeeId: data.AttendeeId,
                Email: data.Email,
                JoinURL: result.data.joinURL,
              });
              //debugger;
            }

            // db.collection("OA_UAT")
            // .doc("UserList").collection("Users").where("Email","==", data.Email)
            // .get()
            // .then((query1) => {

            // alert("aaaaaaaaaa"+query1.docs.length)
            // });
            // }
          });
          console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++");
          debugger;
          console.log(attendeeList);
        });
    },
    OpenLoginReg() {
      self.loginRegDecision();
    },
    openAttendeeAddDialog() {
      bus.$emit("openAddAttendeeDialog");
    },
    promoteAttendee(data, stage) {
      self.showPromoteConfirmDialog = false;
      bus.$emit("toggleLoader", true);
      if (stage == 2) {
        self.showPromoteConfirmDialog = false;
        bus.$emit("toggleLoader", false);
      } else {
        let requestData = {
          data: {
            userIds: [data.id],
          },
        };

        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        };

        axios
          .post(APIs.PromoteAttendeeToSpeakerAPI, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            console.log("responseData>>>>>", responseData);

            if (responseData.data.status == 0) {
              // $("#myModal2").modal("hide");
              self.searchAttendee();

              self.showSnackbar(
                "Attendee promoted successfully.",
                "success",
                "top"
              );
              bus.$emit("toggleLoader", false);
            } else {
              //$("#myModal2").modal("hide");
              self.showSnackbar(
                "Attendee couldn't be promoted, contact support for more information",
                "error",
                "top"
              );
              bus.$emit("toggleLoader", false);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    deleteAttendee(data, stage) {
      self.showDeleteConfirmDialog = false;
      bus.$emit("toggleLoader", true);

      if (stage == 2) {
        self.showDeleteConfirmDialog = false;
        bus.$emit("toggleLoader", false);
      } else {
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: this.$store.state.client[0].id,
            eventId: this.$store.state.eventid,
          },
          data: [
            {
              AttendeeId: data.id,
              Email: data.email,
              Action: "delete",
            },
          ],
        };

        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };

        axios
          .post(APIs.DeleteAttendeeURL, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            if (responseData.data.status == 0) {
              $("#myModal2").modal("hide");
              self.searchAttendee();

              self.showSnackbar(
                "Attendee deleted successfully.",
                "success",
                "top"
              );
              bus.$emit("toggleLoader", false);
            } else {
              $("#myModal2").modal("hide");
              self.showSnackbar(
                "Attendee couldn't be deleted, contact support for more information",
                "error",
                "top"
              );
              bus.$emit("toggleLoader", false);
            }
            // if (
            //   responseData &&
            //   responseData.data &&
            //   responseData.data.status == 0 &&
            //   responseData.data.groups
            // ) {
            //   responseData.data.groups.forEach(function (group) {
            //     if (group.attendees) {
            //       group.attendees.forEach(function (item) {
            //         self.restrictedAttendeeIDs.push(item.AttendeeId);
            //       });
            //     }
            //   });
            // } else {
            //   console.log("Unable to fetch group attendees");
            // }
          })
          .catch((error) => {
            //alert(error);
            console.log(error);
          });
      }
    },
    onTourNext() {
      if ($("#myModal2").is(":visible")) {
        self.steps.pop();
        $("#myModal2").modal("hide");
        bus.$emit("complete-attendee-tour", true);
      }
      self.steps.pop();
      var attendee = self.finalAttendeeList[0];
      self.openModal(
        attendee.id,
        attendee.Name,
        attendee.Company,
        attendee.Title,
        attendee.Image,
        attendee.Email,
        attendee.Phone,
        attendee.Website,
        attendee.Profile,
        attendee.SocialLinks,
        attendee.Initials,
        attendee.RegistrationType,
        attendee.DynamicFields,
        attendee
      );
      $("#myModal2").modal("show");
      self.steps.pop();
      self.steps.splice(0, 0, {
        target: "#v-step-start",
        header: { title: "Edit Attendees:" },
        offset: -200,
        params: { placement: "bottom", positionFixed: true },
        content: "Edit the current Attendee or create a new attendee.",
      });
      self.steps.splice(1, 0, {
        target: "#v-step-start1",
        header: { title: "Advanced Settings 2:" },
        offset: -200,
        params: { placement: "bottom", positionFixed: true },
        content: "Advanced settings for nerds! :)",
      });
      if (self.isAdminComponent) {
        setTimeout(() => {
          self.$tours["attendeeListTour"].start();
        }, 1500);
      }
    },
    editCurrentAttendee() {
      var attendee = {
        Name: this.currentAttendee.Name,
        FirstName: this.currentAttendee.FirstName,
        LastName: this.currentAttendee.LastName,
        Email: this.currentAttendee.Email,
        //Password: randomNumber,
        Tags: this.currentAttendee.Tags,
        Phone: this.currentAttendee.Phone,
        Country: this.currentAttendee.Country,
        FormType: "FREE",
        RegistrationType: {
          ColorCode: "",
          RegistrationType: "Attendee",
          RegistrationTypeId: "",
        },
        Company: this.currentAttendee.Company,
        Designation: this.currentAttendee.Designation,
        Profile: this.currentAttendee.Profile,
        ProfilePictureURL: this.currentAttendee.ProfilePictureURL,
        Website: this.currentAttendee.Website,
        SocialLinks: this.currentAttendee.SocialLinks,
        AttendeeId: this.currentAttendee.id,
      };
      self.closeModal();
      // $("body").removeClass("modal-open");
      // $(".modal-backdrop").remove();

      self.$emit("OpenAddAttendeePopup", attendee);
    },
    OpenAddAttendeePopup() {
      self.$emit("OpenAddAttendeePopup");
    },
    getAttendeeLoggedInStatus(attendeeId) {
      if (self.activeUsersInsideEvent.includes(attendeeId)) {
        return true;
      } else {
        return false;
      }
    },
    filterAttendeeByRegType(regType) {
      $("#RegistrationType_RegistrationType input[type=radio]").prop(
        "checked",
        false
      );
      if (self.selectedLegendRegType != regType) {
        $(
          "#RegistrationType_RegistrationType input[type=radio][value='" +
            regType +
            "']"
        ).prop("checked", true);
      }
      //if (regType == "") {
      //  self.selectedLegendRegType = "";
      //}
      if (self.selectedLegendRegType != regType) {
        self.selectedLegendRegType = regType;
        self.filterAttendee();
      }
    },
    scrollScreen() {
      var scrollingElement = document.scrollingElement || document.body;
      if (this.isScrolled == false) {
        $(scrollingElement).animate(
          {
            scrollTop: document.body.scrollHeight,
          },
          500
        );
        $("#arrow-icon").addClass("arrow-up");
        this.isScrolled = true;
      } else {
        $(scrollingElement).animate(
          {
            scrollTop: 0,
          },
          500
        );
        $("#arrow-icon").removeClass("arrow-up");
        this.isScrolled = false;
      }
    },
    addAttendeeBookMark(attendeeId, Name, Image, isBookmarked) {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 3,
          entityName: Name,
          entityImage: Image ? Image : "",
          entityId: attendeeId,
          entityLink: this.$route.path,
        },
      };
      if (isBookmarked) {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == attendeeId;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = false;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
            self.showSnackbar("Bookmark removed successfully.", "info", "top");
          })
          .catch(() => {});
      } else {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == attendeeId;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = true;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
            self.showSnackbar("Bookmark added successfully.", "info", "top");
          })
          .catch(() => {});
      }
    },
    async addBookMark() {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 3,
          entityName: this.currentAttendee.Name,
          entityImage: this.currentAttendee.Image
            ? this.currentAttendee.Image
            : "",
          entityId: this.currentAttendee.id,
          entityLink: this.$route.path,
        },
      };
      if (this.isBookmarked) {
        this.isBookmarked = false;
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            self.isBookmarked = false;
            debugger;
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == self.currentAttendee.id;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = false;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
          })
          .catch(() => {
            self.isBookmarked = true;
          });
      } else {
        self.isBookmarked = true;
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            debugger;
            self.isBookmarked = true;
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == self.currentAttendee.id;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = true;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
          })
          .catch(() => {
            self.isBookmarked = false;
          });
      }
    },
    async getAttendeeDetails() {
      let self = this;
      //window.addEventListener("scroll", this.onScrollHandler);
      hasMore = true;
      lastVisible = null;

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //window.addEventListener("scroll", this.scroll);
      //document.body.addEventListener("scroll", this.scroll);
      self.getDynamicFieldFilterOptions();
      self.getDynamicFieldDisplayOptions();

      if (obj && obj.eventid) {
        self.eventId = obj.eventid;
      }

      self.attendeeData = [];
      //self.displayAttendees();
      self.searchtext = "";

      //--------get  setting---------------------------------------------------------------------------------

      //-------------dynamic font selection --------------------------------------
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
      //-------------dynamic font selection --------------------------------------

      //-------------------FAVICONJOB------------------------------------------------------------

      if (obj.branding[0].favicon != undefined) {
        if (obj.branding[0].favicon != "") {
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = self.getCDNUrl(obj.branding[0].favicon);
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
      //----------------------------------------------------------------------------------
      /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          obj.eventcollectionname + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          if (brandingData.data.EventInfo != undefined) {
            if (brandingData.data.EventInfo.BodyTextColor != undefined) {
              self.textColor = brandingData.data.EventInfo.BodyTextColor;
            } else {
              self.textColor = "black !important";
            }
          } else {
            self.textColor = "black !important";
          }
          if (!self.isAdminComponent) {
            $("#headerText").css("color", self.textColor);
          }
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }

      //------------------------------------------------------------------------------

      $("#btnAddUserView").click();
      // if ($("#imgBanner")) {
      //   $("#imgBanner").attr("src", self.getCDNUrl(obj.EventBranding[0].banner));
      // }
      common.toggleTopMenu(true);
      common.toggleLeftMenu(true);
      //$("#topmenu").show();
      //$("#leftmenu").show();

      //-------Page Title-------------
      db.collection(obj.eventcollectionname)
        .doc("Menu")
        .get()
        .then((doc) => {
          var data = doc.data();
          $.each(data.AllMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Attendees") {
                let headerText = "";
                if (self.$store.state.locale == "English") {
                  headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  headerText = value.DisplayLabel_zh;
                } else {
                  headerText = value.DisplayLabel;
                }
                if (headerText) {
                  self.headerText = headerText;
                }
                document.title = self.headerText + " - " + obj.eventname;
                // document.getElementById("headerText").innerText =
                //   self.headerText;
              }
            }
          });
          $.each(data.LeftMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Attendees") {
                let headerText = "";
                if (self.$store.state.locale == "English") {
                  headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  headerText = value.DisplayLabel_zh;
                } else {
                  headerText = value.DisplayLabel;
                }
                if (headerText) {
                  self.headerText = headerText;
                }
                document.title = self.headerText + " - " + obj.eventname;
                // document.getElementById("headerText").innerText =
                //   self.headerText;
              }
            }
          });
        });
      //-------Page Title-------------

      /*   if ($("#ulLeftMenu li").length > 0) {
      $("#leftMenuParent").show();
      $("#leftmenu").show();
    } else {
      $("#leftMenuParent").hide();
      $("#leftmenu").hide();
    }*/
      //
      //this.OnIdUrl(self.attendeeData);
      //self.scroll();
      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
      if (!self.isAdminComponent) {
        $("#sectionId").css(
          "background-image",
          "url(" + self.getCDNUrl(obj.EventBranding[0].eventBGImage) + ")"
        );
      }
      self.fetchRegistrationType();

      if (self.$route.query.filter != undefined) {
        if (
          self.$route.query.filter == true ||
          self.$route.query.filter == "true"
        ) {
          self.ShowFilterQuery = true;
        }
      }

      if (self.$route.query.search != undefined) {
        if (
          self.$route.query.search == true ||
          self.$route.query.search == "true"
        ) {
          self.ShowSearchQuery = true;
        }
      }
    },
    toggleFilter(e) {
      self.filterDisplayState = !self.filterDisplayState;
      e.stopPropagation();
    },
    hideFilter() {
      self.filterDisplayState = false;
    },
    collapseOtherFilters(id) {
      //console.log(id);
      let allGroups = $("#filterContent .filter-group");
      let allGroupContents = $("#filterContent .filter-group-content");
      for (var i = 0; i < allGroups.length; i++) {
        let group = allGroups[i];
        console.log(group);
        if (group.id != "a_" + id) {
          //$(group).addClass("collapsed");
          $(group).attr("aria-expanded", "false");
        }
      }
      for (var j = 0; j < allGroupContents.length; j++) {
        let groupContent = allGroupContents[j];
        if (groupContent.id != id) {
          $(groupContent).removeClass("show");
        }
      }
    },
    makeHtmlElementId(id) {
      id = id.replace("a_DynamicFields", "");
      return id;
    },
    preventHideFilter() {
      //e.stopPropagation();
    },
    getDynamicFieldFilterOptions() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (
        obj &&
        obj.eventcollectionname &&
        obj.eventcollectionname.length > 0
      ) {
        db.collection(obj.eventcollectionname)
          .doc("AttendeeList")
          .collection("AttendeeSettings")
          .doc("FilterSettings")
          .get()
          .then(function (doc) {
            if (doc.exists) {
              let data = doc.data();
              data.DynamicFields.forEach(function (item) {
                item.id = item.FieldName.replace(
                  "DynamicFields.",
                  "DynamicFields_"
                )
                  .replace("RegistrationType.", "RegistrationType_")
                  .replace(".value", "_value");
                item.badge = 0;
              });
              self.DynamicFilterOptions = data.DynamicFields;
              //console.log(self.DynamicFilterOptions);
              self.ExcludeCountriesFromFilter = [];
              if (data.ExcludeCountriesFromFilter) {
                data.ExcludeCountriesFromFilter.forEach(function (item) {
                  self.ExcludeCountriesFromFilter.push(item);
                });
              }
              self.getCountryListFromAttendee();

              if (data.MeetingRestrictionEnabled == true) {
                self.meetingRestrictionEnabled = data.MeetingRestrictionEnabled;
              }
              if (data.RegistrationType) {
                self.restrictedRegistrationTypes = data.RegistrationType;
              }
              if (data.ExcludeGroupToRequestMeeting) {
                self.restrictedAttendeeIDs = [];
                debugger;
                let headers = {
                  "content-type": "application/json",
                  Authorization: "Bearer " + self.getSessionToken(),
                };
                let requestData = {
                  key: {
                    instanceId: "OA_UAT",
                    clientId: self.clientID,
                    eventId: self.eventId,
                  },
                  data: {
                    groups: [
                      {
                        GroupId: data.ExcludeGroupToRequestMeeting,
                      },
                    ],
                  },
                };
                axios
                  .post(APIs.GetAttendees, requestData, {
                    headers: headers,
                  })
                  .then((responseData) => {
                    if (
                      responseData &&
                      responseData.data &&
                      responseData.data.status == 0 &&
                      responseData.data.groups
                    ) {
                      responseData.data.groups.forEach(function (group) {
                        if (group.attendees) {
                          group.attendees.forEach(function (item) {
                            self.restrictedAttendeeIDs.push(item.AttendeeId);
                          });
                        }
                      });
                    } else {
                      console.log("Unable to fetch group attendees");
                    }
                  })
                  .catch((error) => {
                    //alert(error);
                    console.log(error);
                  });

                //db.collection(obj.eventcollectionname)
                //  .doc("GroupList")
                //  .collection("Groups")
                //  .doc(data.ExcludeGroupToRequestMeeting)
                //  .get()
                //  .then(function (doc) {
                //    if (doc.exists) {
                //      let data = doc.data();
                //      //alert(data.Attendees.length);
                //      data.Attendees.forEach(function (item) {
                //        self.restrictedAttendeeIDs.push(item.AttendeeId);
                //      });
                //    }
                //  })
                //  .catch(function (error) {
                //    alert(error);
                //    console.log("Error : " + error);
                //  });
              }
            } else {
              //alert("Not Found");
            }
          })
          .catch(function (error) {
            console.log("Error : " + error);
          });
      }
    },
    getCountryListFromAttendee() {
      let countryFilter = self.DynamicFilterOptions.filter(function (item) {
        return item.FieldName == "Country";
      });
      if (countryFilter.length > 0) {
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventId,
          },
        };
        axios
          .post(APIs.UserCountryList, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            if (responseData) {
              console.log(responseData.data.countries);
              let countryList = [];
              //Object.keys(responseData.data.countries).forEach(function (item) {
              //  countryList.push(item);
              //});
              debugger;
              responseData.data.countries.forEach(function (item) {
                if (!self.ExcludeCountriesFromFilter.includes(item.name)) {
                  countryList.push(item.name);
                }
              });

              countryList.sort(function (a, b) {
                let aName = a.trim().toLowerCase();
                let bName = b.trim().toLowerCase();
                if (aName < bName) {
                  return -1;
                }
                if (aName > bName) {
                  return 1;
                }
                return 0;
              });

              //console.log(countryList);
              if (countryList.length > 0) {
                countryFilter[0].Options = countryList;
              }
            }
            //console.log(responseData);
          })
          .catch((error) => {
            //alert(error);
            console.log(error);
          });
      }
    },
    getDynamicFieldDisplayOptions() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (
        obj &&
        obj.eventcollectionname &&
        obj.eventcollectionname.length > 0
      ) {
        db.collection(obj.eventcollectionname)
          .doc("AttendeeList")
          .collection("AttendeeSettings")
          .doc("ExcludeFields")
          .get()
          .then(function (doc) {
            if (doc.exists) {
              let data = doc.data();
              self.DynamicFieldsExcludeOptions = data.DynamicFields;
              self.StaticFieldsExcludeOptions = data;
              //alert(self.DynamicFieldsExcludeOptions.length);
            } else {
              //alert("Not Found");
            }
          })
          .catch(function (error) {
            console.log("Error : " + error);
          });
      }
    },
    createDynamicFieldFilterOptions() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (
        obj &&
        obj.eventcollectionname &&
        obj.eventcollectionname.length > 0
      ) {
        db.collection(obj.eventcollectionname)
          .doc("AttendeeList")
          .collection("AttendeeSettings")
          .doc("FilterSettings")
          .get()
          .then(function (doc) {
            let dynamicFilterOptions = [
              {
                AllowMultiSelect: false,
                DisplayLabel: "Country",
                FieldName: "Country",
                Operator: "==",
                Options: [
                  //"United States",
                  //"Afghanistan",
                  //"Albania",
                  //"Algeria",
                  //"American Samoa",
                  //"Andorra",
                  //"Angola",
                  //"Anguilla",
                  //"Antigua and Barbuda",
                  //"Argentina",
                  //"Armenia",
                  //"Aruba",
                  //"Australia",
                  //"Austria",
                  //"Azerbaijan",
                  //"The Bahamas",
                  //"Bahrain",
                  //"Bangladesh",
                  //"Barbados",
                  //"Belarus",
                  //"Belgium",
                  //"Belize",
                  //"Benin",
                  //"Bermuda",
                  //"Bhutan",
                  //"Bolivia",
                  //"Bosnia and Herzegovina",
                  //"Botswana",
                  //"Brazil",
                  //"Brunei",
                  //"Bulgaria",
                  //"Burkina Faso",
                  //"Burundi",
                  //"Cambodia",
                  //"Cameroon",
                  //"Canada",
                  //"Cape Verde",
                  //"Cayman Islands",
                  //"Central African Republic",
                  //"Chad",
                  //"Chile",
                  //"China",
                  //"Christmas Island",
                  //"Cocos (Keeling) Islands",
                  //"Colombia",
                  //"Comoros",
                  //"Congo",
                  //"Cook Islands",
                  //"Costa Rica",
                  //"Cote d'Ivoire",
                  //"Croatia",
                  //"Cuba",
                  //"Curacao",
                  //"Cyprus",
                  //"Czech Republic",
                  //"Democratic Republic of the Congo",
                  //"Denmark",
                  //"Djibouti",
                  //"Dominica",
                  //"Dominican Republic",
                  //"Ecuador",
                  //"Egypt",
                  //"El Salvador",
                  //"Equatorial Guinea",
                  //"Eritrea",
                  //"Estonia",
                  //"Ethiopia",
                  //"Falkland Islands",
                  //"Faroe Islands",
                  //"Fiji",
                  //"Finland",
                  //"France",
                  //"French Polynesia",
                  //"Gabon",
                  //"The Gambia",
                  //"Georgia",
                  //"Germany",
                  //"Ghana",
                  //"Gibraltar",
                  //"Greece",
                  //"Greenland",
                  //"Grenada",
                  //"Guadeloupe",
                  //"Guam",
                  //"Guatemala",
                  //"Guernsey",
                  //"Guinea",
                  //"Guinea-Bissau",
                  //"Guyana",
                  //"Haiti",
                  //"Honduras",
                  //"Hong Kong",
                  //"Hungary",
                  //"Iceland",
                  //"India",
                  //"Indonesia",
                  //"Iran",
                  //"Iraq",
                  //"Ireland",
                  //"Israel",
                  //"Italy",
                  //"Jamaica",
                  //"Japan",
                  //"Jersey",
                  //"Jordan",
                  //"Kazakhstan",
                  //"Kenya",
                  //"Kiribati",
                  //"North Korea",
                  //"South Korea",
                  //"Kosovo",
                  //"Kuwait",
                  //"Kyrgyzstan",
                  //"Laos",
                  //"Latvia",
                  //"Lebanon",
                  //"Lesotho",
                  //"Liberia",
                  //"Libya",
                  //"Liechtenstein",
                  //"Lithuania",
                  //"Luxembourg",
                  //"Macau",
                  //"Macedonia",
                  //"Madagascar",
                  //"Malawi",
                  //"Malaysia",
                  //"Maldives",
                  //"Mali",
                  //"Malta",
                  //"Marshall Islands",
                  //"Martinique",
                  //"Mauritania",
                  //"Mauritius",
                  //"Mayotte",
                  //"Mexico",
                  //"Micronesia",
                  //"Moldova",
                  //"Monaco",
                  //"Mongolia",
                  //"Montenegro",
                  //"Montserrat",
                  //"Morocco",
                  //"Mozambique",
                  //"Myanmar",
                  //"Nagorno-Karabakh",
                  //"Namibia",
                  //"Nauru",
                  //"Nepal",
                  //"Netherlands",
                  //"Netherlands Antilles",
                  //"New Caledonia",
                  //"New Zealand",
                  //"Nicaragua",
                  //"Niger",
                  //"Nigeria",
                  //"Niue",
                  //"Norfolk Island",
                  //"Turkish Republic of Northern Cyprus",
                  //"Northern Mariana",
                  //"Norway",
                  //"Oman",
                  //"Pakistan",
                  //"Palau",
                  //"Palestine",
                  //"Panama",
                  //"Papua New Guinea",
                  //"Paraguay",
                  //"Peru",
                  //"Philippines",
                  //"Pitcairn Islands",
                  //"Poland",
                  //"Portugal",
                  //"Puerto Rico",
                  //"Qatar",
                  //"Republic of the Congo",
                  //"Romania",
                  //"Russia",
                  //"Rwanda",
                  //"Saint Barthelemy",
                  //"Saint Helena",
                  //"Saint Kitts and Nevis",
                  //"Saint Lucia",
                  //"Saint Martin",
                  //"Saint Pierre and Miquelon",
                  //"Saint Vincent and the Grenadines",
                  //"Samoa",
                  //"San Marino",
                  //"Sao Tome and Principe",
                  //"Saudi Arabia",
                  //"Senegal",
                  //"Serbia",
                  //"Seychelles",
                  //"Sierra Leone",
                  //"Singapore",
                  //"Slovakia",
                  //"Slovenia",
                  //"Solomon Islands",
                  //"Somalia",
                  //"Somaliland",
                  //"South Africa",
                  //"South Ossetia",
                  //"South Sudan",
                  //"Spain",
                  //"Sri Lanka",
                  //"Sudan",
                  //"Suriname",
                  //"Svalbard",
                  //"eSwatini",
                  //"Sweden",
                  //"Switzerland",
                  //"Syria",
                  //"Taiwan",
                  //"Tajikistan",
                  //"Tanzania",
                  //"Thailand",
                  //"Timor-Leste",
                  //"Togo",
                  //"Tokelau",
                  //"Tonga",
                  //"Transnistria Pridnestrovie",
                  //"Trinidad and Tobago",
                  //"Tristan da Cunha",
                  //"Tunisia",
                  //"Turkey",
                  //"Turkmenistan",
                  //"Turks and Caicos Islands",
                  //"Tuvalu",
                  //"Uganda",
                  //"Ukraine",
                  //"United Arab Emirates",
                  //"United Kingdom",
                  //"Uruguay",
                  //"Uzbekistan",
                  //"Vanuatu",
                  //"Vatican City",
                  //"Venezuela",
                  //"Vietnam",
                  //"British Virgin Islands",
                  //"Isle of Man",
                  //"US Virgin Islands",
                  //"Wallis and Futuna",
                  //"Western Sahara",
                  //"Yemen",
                  //"Zambia",
                  //"Zimbabwe",
                ],
              },
              {
                AllowMultiSelect: false,
                DisplayLabel: "Company Name",
                FieldName: "Company",
                Operator: "==",
                Options: [
                  "137 Pillars Hotels & Resorts",
                  "500Rai Floating Resort - Surat Inter Tour Co., Ltd.",
                  "ATOM RESERVATIONS",
                  "Abercrombie & Kent Southeast Asia DMCs",
                  "Amatara Wellness Resort",
                  "Anahata Resort Koh Samui",
                  "Aonang Princeville Villa Resort & Spa, Krabi",
                  "Asia Exotica",
                  "Audley Travel",
                  "Avani Hotels & Resorts",
                  "Avanti Destinations",
                  "Bangkok Airways PCL",
                  "Bangkok Trip Planner",
                  "Banyan Tree Hotel Group",
                  "Blue Voyage Thailand",
                  "CATIVA OPERADORA",
                  "Classic Vacations, LLC",
                  "Co van Kessel Bangkok Tours.Co.,Ltd.",
                  "Discova",
                  "Diversa Turismo",
                  "EXO Travel",
                  "Elite Voyages",
                  "EVA Airways",
                  "Four Seasons Hotel Bangkok at Chao Phraya River",
                  "Gala Holidays",
                  "GO by The Glory Worldwide Travel",
                  "Golfasian Co. Ltd",
                  "ICS Travel Group",
                  "Japan Airlines",
                  "LM TRAVEL EXPERIENCE",
                  "Local Alike Co., Ltd.",
                  "Macrotour",
                  "Minor / Anantara Hotels",
                  "Miskawaan Health Group",
                  "Movenpick BDMS Wellness Resort Bangkok",
                  "Muang Samui Group",
                  "New Star Beach Resort",
                  "Orientur",
                  "Pleasant Holidays",
                  "Pleasant Holidays LLC",
                  "QATAR AIRWAYS",
                  "RAKxa Wellness & Medical Retreat",
                  "Raidho Tour Operator",
                  "Rayavadee Krabi",
                  "SAYANG HOLIDAYS LLC",
                  "Sarastro Pasaktong Co. Ltd.,",
                  "Siam Kempinski Hotel Bangkok",
                  "SO/ Bangkok",
                  "Suuko Wellness & Spa Resort",
                  "TGK Travel",
                  "The Peninsula Bangkok",
                  "The Racha",
                  "The Siam",
                  "The Slate",
                  "The Wedding Bliss Thailand",
                  "Tour & Travel Organizers Ltd",
                  "Tourism Authority of Thailand",
                  "Trikaya Tours",
                  "True Leasing Co., Ltd",
                  "WAREERAK HOT SPRING & WELLNESS",
                  "Wonderland Healing Center",
                  "Ásia Total",
                ],
              },
              {
                AllowMultiSelect: false,
                DisplayLabel: "Registered As",
                FieldName: "RegistrationType.RegistrationType",
                Operator: "==",
                Options: ["Tour Operator", "Travel Agent", "Media", "Supplier"],
              },
              //{
              //  AllowMultiSelect: false,
              //  DisplayLabel: "Registered As",
              //  FieldName:
              //    "DynamicFields.49c9a6db-6bc9-424a-8e67-91da390e45d7.value",
              //  Operator: "==",
              //  Options: ["Tour Operator", "Travel Agent", "Media"],
              //},
              {
                AllowMultiSelect: false,
                DisplayLabel: "Travel Segments",
                FieldName:
                  "DynamicFields.494cb996-95c6-47b8-901d-2ff19c2f1b46.value",
                Operator: "==",
                Options: [
                  "Active Travel",
                  "Romance",
                  "Wellness",
                  "Budget Holidays",
                  "Luxury Holidays",
                  "Leisure/ Groups/ Fixed Departure",
                  "MICE",
                ],
              },
              {
                AllowMultiSelect: false,
                DisplayLabel: "Destinations",
                FieldName: "RegionsServed",
                Operator: "==",
                Options: ["Bangkok", "Central", "Nationwide", "North", "South"],
              },
              {
                AllowMultiSelect: false,
                DisplayLabel: "Type of Business",
                FieldName: "TypeOfBusiness",
                Operator: "==",
                Options: [
                  "Airline",
                  "DMC",
                  "Health & Spa",
                  "Hotel",
                  "Sports",
                  "Transportation",
                  "Others",
                ],
              },
              //{
              //  AllowMultiSelect: true,
              //  DisplayLabel: "Interessiertes Thema",
              //  FieldName: "DynamicFields.q62_interestedIn.value",
              //  Operator: "array-contains-any",
              //  Options: [
              //    "Big Data & Analytics",
              //    "Cloud",
              //    "Service Providing",
              //    "Cybersecurity",
              //    "Data Center",
              //    "DSGVO",
              //    "IoT",
              //    "Mobility & Enduser Computing",
              //    "Storage",
              //    "Virtualisierung",
              //  ],
              //},
              //{
              //  AllowMultiSelect: false,
              //  DisplayLabel: "Registration Type",
              //  FieldName: "RegistrationType.RegistrationType",
              //  Operator: "==",
              //  Options: ["Suppliers", "Advisors"],
              //},
              //{
              //  AllowMultiSelect: false,
              //  DisplayLabel: "Designation",
              //  FieldName: "Designation",
              //  Operator: "==",
              //  Options: [
              //    "Co-Founder",
              //    "FOUNDER",
              //    "Owner",
              //    "Managing Partner",
              //    "Propritor",
              //  ],
              //},
              //{
              //  AllowMultiSelect: true,
              //  DisplayLabel: "Interessiertes Thema",
              //  FieldName: "DynamicFields.q62_interestedIn.value",
              //  Operator: "array-contains-any",
              //  Options: [
              //    "Big Data & Analytics",
              //    "Cloud",
              //    "Service Providing",
              //    "Cybersecurity",
              //    "Data Center",
              //    "DSGVO",
              //    "IoT",
              //    "Mobility & Enduser Computing",
              //    "Storage",
              //    "Virtualisierung",
              //  ],
              //},
              //{
              //  AllowMultiSelect: true,
              //  DisplayLabel: "Losungsthemen",
              //  FieldName: "DynamicFields.q63_expertIn.value",
              //  Operator: "array-contains-any",
              //  Options: [
              //    "Big Data & Analytics",
              //    "Cloud",
              //    "Service Providing",
              //    "Cybersecurity",
              //    "Data Center",
              //    "DSGVO",
              //    "IoT",
              //    "Mobility & Enduser Computing",
              //    "Storage",
              //    "Virtualisierung",
              //  ],
              //},
              //{
              //  AllowMultiSelect: true,
              //  DisplayLabel: "Arrow Leistungen",
              //  FieldName: "DynamicFields.q68_ArrowServices.value",
              //  Operator: "array-contains-any",
              //  Options: [
              //    "Cloud Marketplace (ArrowSphere)",
              //    "White Labeled Enduser Cloud Marketplace (Arrow MyCloud Portal)",
              //    "Finanzierungsmöglichkeiten",
              //    "individuelle Lösungskonzepte",
              //    "IoT Projektbegleitung",
              //    "Marketing & Leadgenerierung",
              //    "Pre-Sales & Consulting",
              //    "Sicherer Datenträgertransport",
              //    "Support Services & Hardwareaustausch",
              //    "Training & Education",
              //    "Global Delivery",
              //  ],
              //},
            ];
            if (!doc.exists) {
              //alert(obj.eventcollectionname);
              db.collection(obj.eventcollectionname)
                .doc("AttendeeList")
                .collection("AttendeeSettings")
                .doc("FilterSettings")
                .set({ DynamicFields: dynamicFilterOptions })
                .then(function () {
                  //alert("Saved");
                })
                .catch(function (error) {
                  alert("Error : " + error);
                });
            } else {
              //alert("Exists");
              db.collection(obj.eventcollectionname)
                .doc("AttendeeList")
                .collection("AttendeeSettings")
                .doc("FilterSettings")
                .update({ DynamicFields: dynamicFilterOptions })
                .then(function () {
                  //alert("Saved");
                })
                .catch(function (error) {
                  alert("Error : " + error);
                });
            }
          })
          .catch(function (error) {
            alert("Error : " + error);
          });
      }
    },
    createDynamicFieldDisplayOptions() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (
        obj &&
        obj.eventcollectionname &&
        obj.eventcollectionname.length > 0
      ) {
        db.collection(obj.eventcollectionname)
          .doc("AttendeeList")
          .collection("AttendeeSettings")
          .doc("ExcludeFields")
          .get()
          .then(function (doc) {
            if (!doc.exists) {
              //let fieldOptions = ["q72_Consent1", "q73_Concent2"];
              let fieldOptions = ["5303eee8-ae94-452d-b967-89f17c778dc4 "];
              db.collection(obj.eventcollectionname)
                .doc("AttendeeList")
                .collection("AttendeeSettings")
                .doc("ExcludeFields")
                .set({ RegistrationType: false, DynamicFields: fieldOptions })
                .then(function () {
                  alert("Saved");
                })
                .catch(function (error) {
                  alert("Error : " + error);
                });
            } else {
              alert("Already Exist");
            }
          })
          .catch(function (error) {
            alert("Error : " + error);
          });
      }
    },
    allowMeeting(registrationType) {
      var result = true;
      if (self.meetingRestrictionEnabled) {
        if (self.restrictedRegistrationTypes) {
          if (self.restrictedRegistrationTypes.length > 0) {
            result = false;
            var regType = "";
            if (typeof registrationType == "string") {
              regType = registrationType;
            } else if (typeof registrationType == "object") {
              regType = registrationType.RegistrationType;
            }
            self.restrictedRegistrationTypes.forEach(function (item) {
              if (item.From == self.myRegistrationType) {
                if (item.To.includes(regType)) {
                  result = true;
                }
              }
            });
          }
        }
      }
      return result;
    },
    clearAllFilter: function () {
      $("input.dynamic-filter-option:checked").prop("checked", false);
      self.DynamicFilterOptions.forEach(function (item) {
        item.badge = 0;
      });
      self.selectedLegendRegType = "All";
      self.filterAttendee();
    },
    filterAttendee: function (e) {
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.pageCount = 0;
      hasMore = true;
      lastVisible = null;
      self.attendeeData = [];
      //self.displayAttendees();
      self.applyFilter();
      if (e) {
        e.stopPropagation();
      }
    },
    applyFilter() {
      //let selectedItems1 = $(
      //  "input.dynamic-filter-option[type='radio']:checked"
      //);
      //let selectedItems2 = $(
      //  "input.dynamic-filter-option[type='checkbox']:checked"
      //);
      //let selectedItems = selectedItems1.concat(selectedItems2);
      let selectedItems = $("input.dynamic-filter-option:checked");
      let requestData = { search: [], filter: [] };
      //requestData.filter.push({
      //  key: "IsPublished",
      //  operator: "==",
      //  value: true,
      //});
      self.DynamicFilterOptions.forEach(function (item) {
        item.badge = 0;
      });
      if (selectedItems.length > 0) {
        for (var i = 0; i < selectedItems.length; i++) {
          //alert(selectedItems[i].name+":"+selectedItems[i].value);
          let fields = self.DynamicFilterOptions.filter(function (item) {
            return item.FieldName == selectedItems[i].name;
          });
          if (fields.length > 0) {
            let field = fields[0];
            field.badge++;
            if (field.Operator == "==" || field.Operator == "array-contains") {
              //alert(field.FieldName);
              //alert(field.Operator);
              //alert(selectedItems[i].value);
              requestData.filter.push({
                key: field.FieldName,
                operator: field.Operator,
                value: selectedItems[i].value,
              });
              if (field.FieldName == "RegistrationType.RegistrationType") {
                self.selectRegTypeLegend(selectedItems[i].value);
              }
            } else {
              let filter = requestData.filter.filter(function (item) {
                return item.key == field.FieldName;
              });
              if (filter.length > 0) {
                filter[0].value.push(selectedItems[i].value);
              } else {
                //alert(field.FieldName);
                //alert(field.Operator);
                //alert(selectedItems[i].value);
                requestData.filter.push({
                  key: field.FieldName,
                  operator: field.Operator,
                  value: [selectedItems[i].value],
                });
                if (field.FieldName == "RegistrationType.RegistrationType") {
                  self.selectRegTypeLegend(selectedItems[i].value);
                }
              }
            }
          }
        }
      } else {
        if (self.selectedLegendRegType.toLowerCase() != "all") {
          requestData.filter.push({
            key: "RegistrationType.RegistrationType",
            operator: "==",
            value: self.selectedLegendRegType,
          });
        }
      }
      if (!self.searchtext) {
        self.searchtext = "";
      }
      var searchText = "";
      if (self.searchtext) {
        searchText = self.searchtext.trim().toLowerCase();
      }
      if (self.searchtext) {
        requestData.search.push({
          key: "Name",
          operator: "LIKE",
          value: searchText,
        });
        requestData.search.push({
          key: "Company",
          operator: "LIKE",
          value: searchText,
        });
        requestData.search.push({
          key: "Designation",
          operator: "LIKE",
          value: searchText,
        });
        requestData.search.push({
          key: "Profile",
          operator: "LIKE",
          value: searchText,
        });
        requestData.search.push({
          key: "Tags",
          operator: "LIKE",
          value: searchText,
        });
        //requestData.search.push({
        //  key: "Tags",
        //  operator: "array-contains-any",
        //  value: searchText,
        //});
      }
      requestData.sort = {
        sortBy: self.AttendeeListSortBy,
        sortOrder: self.AttendeeListSorDirection,
      };
      //if (requestData.search.length > 0 || requestData.filter.length) {
      if (requestData.filter.length > 0) {
        self.hasFilterOrSearch = true;
      } else {
        self.hasFilterOrSearch = false;
      }
      console.log("Filter: " + requestData);
      self.displayAttendees(requestData);
    },
    selectRegTypeLegend(regType) {
      //alert("selectRegTypeLegend: " + regType);
      self.selectedLegendRegType = regType;
    },
    GetPluginSettings: function () {
      if (self.eventcollection) {
        db.collection(self.eventcollection)
          .doc("EventInfo")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (
                data.Plugins &&
                data.Plugins.OneToOneChat &&
                data.Plugins.OneToOneChat.IsEnabled
              ) {
                self.OneToOneChatEnabled = true;
              }
            }
          });
        db.collection(self.eventcollection)
          .doc("Settings")
          .collection("chat")
          .doc("ChatGroupSettings")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (data.EnableOneToOneVideoCall) {
                self.OneToOneVideoCallEnabled = data.EnableOneToOneVideoCall;
              }
            }
          });
      }
    },
    async OpenOneToOneChat(data, startVideoCall) {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        for (let i = 0; i < self.attendeeData.length; i++) {
          if (data.AttendeeId == self.attendeeData[i].AttendeeId) {
            self.attendeeData[i].AttendeeKey++;
            break;
          }
        }
        return;
      }
      for (let i = 0; i < self.attendeeData.length; i++) {
        if (data.AttendeeId == self.attendeeData[i].AttendeeId) {
          if (startVideoCall) {
            self.attendeeData[i].StartingVideoCall = true;
            self.attendeeData[i].AttendeeKey++;
            break;
          } else {
            self.attendeeData[i].StartingChat = true;
            self.attendeeData[i].AttendeeKey++;
            break;
          }
        }
      }
      self.attendeeData = self.attendeeData.filter(function () {
        return true;
      });
      //var roomList = [];
      db.collection(self.eventcollection)
        .doc("group-chat")
        .collection("chat-rooms")
        .where("userIdList", "array-contains", self.loggedInUseID)
        //.where("userIdList", "array-contains", data.AttendeeId)
        .get()
        .then(async (querySnapshot) => {
          var roomId = "";
          var memberIDs = [];
          for (var i = 0; i < querySnapshot.docs.length; i++) {
            var room = querySnapshot.docs[i].data();
            if (
              room.userIdList &&
              room.userIdList.length == 2 &&
              room.userIdList.includes(data.AttendeeId)
            ) {
              roomId = room.id;
              memberIDs = room.userIdList;
              data.roomId = room.id;
              data.roomName = room.name ? room.name.trim() : "";
              data.createdBy = room.createdByUserId;
              data.roomMembers = room.userIdList;
              data.lastMessage = room.lastMsg;
              data.createdDateTime = room.createdDateTime.seconds;
              data.lastActiveTime = room.lastActivityDtm.seconds;
              data.iconUrl = self.getCDNUrl(room.iconUrl);
            }
          }
          if (!roomId) {
            var roomData = await self.CreateChatRoom(data);
            if (roomData && roomData.status == 0 && roomData.roomId) {
              self.OpenOneToOneChat(data, startVideoCall);
              return;
            } else {
              alert("Something went wrong creating chat room");
              return;
            }
          }
          setTimeout(() => {
            for (let i = 0; i < self.attendeeData.length; i++) {
              if (data.AttendeeId == self.attendeeData[i].AttendeeId) {
                self.attendeeData[i].StartingVideoCall = false;
                self.attendeeData[i].StartingChat = false;
                break;
              }
            }
            self.attendeeData = self.attendeeData.filter(function () {
              return true;
            });
          }, 5000);
          //bus.$emit("toggleLoader", true);
          if (startVideoCall) {
            if (roomId && memberIDs.length > 0) {
              var attendees = [];
              for (let i = 0; i < self.attendeeData.length; i++) {
                if (memberIDs.includes(self.attendeeData[i].AttendeeId)) {
                  attendees.push({
                    AttendeeId: self.attendeeData[i].AttendeeId,
                    Name: self.attendeeData[i].Name,
                    ProfilePictureURL: self.attendeeData[i].ProfilePictureURL,
                    Tags: common.getInitials(self.attendeeData[i].Name),
                  });
                }
                if (attendees.length == memberIDs.length) {
                  break;
                }
              }
              bus.$emit("inititalVideoChat", {
                roomId: roomId,
                memberIDs: memberIDs,
                attendees: attendees,
                sendChat: true,
                sendNotification: true,
              });
            }
          } else {
            bus.$emit("openExpoIndividualChat", data);
          }
        });
    },
    async CreateChatRoom(attendee) {
      return new Promise((resolve, reject) => {
        var clientId = self.getClientId();
        var eventId = self.getEventId();
        var user = self.getSessionUserProfile();
        var memberList = [];
        var groupName = user.Name + "&" + attendee.Name;
        memberList.push(user.UserId);
        memberList.push(attendee.AttendeeId);
        var requestData = {};
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };
        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: clientId,
            eventId: eventId,
          },
          data: {
            roomName: groupName,
            userIdList: memberList,
          },
        };
        axios
          .post(APIs.CreateRoom, JSON.stringify(requestData), {
            headers: headers,
          })
          .then((responseData) => {
            if (responseData.data.status == 0) {
              //alert(responseData.data.roomId);
              //roomId = responseData.data.roomId;
              resolve({
                roomId: responseData.data.roomId,
                Message: "",
                status: 0,
              });
            } else {
              reject({
                Message: "Something went wrong",
                status: -1,
              });
            }
          })
          .catch((error) => {
            console.log("Error:" + error);
            reject({
              Message: "Error:" + error,
              status: -1,
            });
          });
      });
    },
    ScheduleMeeting(attendee = null) {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      self.requestMeetingKey++;
      self.currentAttendee = attendee;
      self.currentAttendeeName = attendee.Name;

      // $("#hdnAttendeeId").val(attendee.id);
      // self.OpenRequestMeeting();
      if ($("#aFacebok")) $("#aFacebok").hide();
      if ($("#aTwitter")) $("#aTwitter").hide();
      if ($("#aLikedin")) $("#aLikedin").hide();
      $("#hdnAttendeeId").val(attendee.id);
      var hdnattendeeId = attendee.id;
      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: {
          attendeeId: hdnattendeeId,
          showDatePicker: true,
          attendee: attendee,
        },
      });
      instance.$mount();
    },
    OpenRequestMeeting(e) {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        e.stopPropagation();
        return;
      }
      self.requestMeetingKey++;
      // $("#ReqMeeting .calendar-wrap").show();
      //    $("#ReqMeeting .modal-body-wrapper2").hide();
      //    $("#ReqMeeting .modal-body-wrapper3").hide();

      // //
      //if (document.getElementById("dvImgeHldText").innerText == "") {
      //  var AttendeeImgPath = document.getElementById("imgModalAttendee").src;

      //  if (AttendeeImgPath != null && AttendeeImgPath != "") {
      //    document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
      //  }

      //  $("#ReqAttendeeImage").show();
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerText = "";
      //    $("#ReqdivImgHldText").hide();
      //  }
      //} else {
      //  var Initials = document.getElementById("dvImgeHldText").innerText;
      //  $("#ReqAttendeeImage").attr("src", "");
      //  $("#ReqAttendeeImage").hide();
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerHTML =
      //      "<h4>" + Initials + "</h4>";
      //    $("#ReqdivImgHldText").show();
      //  }
      //}

      // $("#hdnMSAttendeeId").val($("#hdnAttendeeId").val());
      //if (document.getElementById("ReqAttendeeName")) {
      //  document.getElementById("ReqAttendeeName").innerText =
      //    document.getElementById("modalName").innerText;
      //}
      //if (document.getElementById("ReqAttendeeNameh4")) {
      //  document.getElementById("ReqAttendeeNameh4").innerText =
      //    document.getElementById("ReqAttendeeName").innerText;
      //}
      //if (document.getElementById("ReqAttendeeTitle")) {
      //  document.getElementById("ReqAttendeeTitle").innerText =
      //    document.getElementById("modalTtile").innerText;
      //}
      //if (document.getElementById("ReqAttendeeCompany")) {
      //  document.getElementById("ReqAttendeeCompany").innerText =
      //    document.getElementById("modalCompany").innerText;
      //}
      //if (document.getElementById("modalEmail").innerText !== "") {
      //  if (
      //    document
      //      .getElementById("modalEmail")
      //      .innerText.substring(
      //        document.getElementById("modalEmail").innerText.length,
      //        document.getElementById("modalEmail").innerText.length - 1
      //      ) !== "#"
      //  ) {
      //    document.getElementById("ReqAttendeeEmail").href =
      //      document.getElementById("modalEmail").innerText;
      //    if (
      //      document.getElementById("ReqAttendeeEmail").href.indexOf("mailto") <
      //      0
      //    ) {
      //      $("#ReqAttendeeEmail").text(
      //        document.getElementById("modalEmail").innerText
      //      );
      //      document.getElementById("ReqAttendeeEmail").href =
      //        "mailto:" + document.getElementById("ReqAttendeeEmail").href;
      //    }
      //    $("#ReqAttendeeEmail").parent().show();
      //  } else {
      //    $("#ReqAttendeeEmail").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeeEmail").parent().hide();
      //}

      //if (document.getElementById("modalPhone").innerText !== "") {
      //  if (
      //    document
      //      .getElementById("modalPhone")
      //      .innerText.substring(
      //        document.getElementById("modalPhone").innerText.length,
      //        document.getElementById("modalPhone").innerText.length - 1
      //      ) !== "#"
      //  ) {
      //    document.getElementById("ReqAttendeePhone").href =
      //      document.getElementById("modalPhone").innerText;
      //    if (
      //      document.getElementById("ReqAttendeePhone").href.indexOf("tel") < 0
      //    ) {
      //      $("#ReqAttendeePhone").text(
      //        document.getElementById("modalPhone").innerText
      //      );
      //      document.getElementById("ReqAttendeePhone").href =
      //        "tel:" + document.getElementById("ReqAttendeePhone").href;
      //    }
      //    $("#ReqAttendeePhone").parent().show();
      //  } else {
      //    $("#ReqAttendeePhone").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeePhone").parent().hide();
      //}

      //if (document.getElementById("modalWebsite").innerText !== "") {
      //  if (
      //    document
      //      .getElementById("modalWebsite")
      //      .innerText.substring(
      //        document.getElementById("modalWebsite").innerText.length,
      //        document.getElementById("modalWebsite").innerText.length - 1
      //      ) !== "#"
      //  ) {
      //    document.getElementById("ReqAttendeeWebsite").href =
      //      document.getElementById("modalWebsite").innerText;
      //    if (
      //      document.getElementById("ReqAttendeeWebsite").href.indexOf("http") <
      //      0
      //    ) {
      //      $("#ReqAttendeeWebsite").text(
      //        document.getElementById("modalWebsite").innerText
      //      );
      //      document.getElementById("ReqAttendeeWebsite").href =
      //        "http://" + document.getElementById("ReqAttendeeWebsite").href;
      //    }
      //    $("#ReqAttendeeWebsite").parent().show();
      //  } else {
      //    $("#ReqAttendeeWebsite").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeeWebsite").parent().hide();
      //}

      if (document.getElementById("anchFacebook").href !== "") {
        if (
          document
            .getElementById("anchFacebook")
            .href.substring(
              document.getElementById("anchFacebook").href.length,
              document.getElementById("anchFacebook").href.length - 1
            ) !== "#"
        ) {
          document.getElementById("aFacebok").href =
            document.getElementById("anchFacebook").href;
          if (document.getElementById("aFacebok").href.indexOf("http") < 0) {
            document.getElementById("aFacebok").href =
              "http://" + document.getElementById("aFacebok").href;
          }
          $("#aFacebok").show();
        } else {
          $("#aFacebok").hide();
        }
      } else {
        $("#aFacebok").hide();
      }

      if (document.getElementById("anchTwitter").href !== "") {
        if (
          document
            .getElementById("anchTwitter")
            .href.substring(
              document.getElementById("anchTwitter").href.length,
              document.getElementById("anchTwitter").href.length - 1
            ) !== "#"
        ) {
          document.getElementById("aTwitter").href =
            document.getElementById("anchTwitter").href;
          if (document.getElementById("aTwitter").href.indexOf("http") < 0) {
            document.getElementById("aTwitter").href =
              "http://" + document.getElementById("aTwitter").href;
          }
          $("#aTwitter").show();
        } else {
          $("#aTwitter").hide();
        }
      } else {
        $("#aTwitter").hide();
      }

      if (document.getElementById("anchLinkedIn").href !== "") {
        if (
          document
            .getElementById("anchLinkedIn")
            .href.substring(
              document.getElementById("anchLinkedIn").href.length,
              document.getElementById("anchLinkedIn").href.length - 1
            ) !== "#"
        ) {
          document.getElementById("aLikedin").href =
            document.getElementById("anchLinkedIn").href;
          if (document.getElementById("aLikedin").href.indexOf("http") < 0) {
            document.getElementById("aLikedin").href =
              "http://" + document.getElementById("aLikedin").href;
          }
          $("#aLikedin").show();
        } else {
          $("#aLikedin").hide();
        }
      } else {
        $("#aLikedin").hide();
      }

      var hdnattendeeId = $("#hdnattendeeId").val();

      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: {
          attendeeId: hdnattendeeId,
          showDatePicker: true,
          attendee: this.currentAttendee,
        },
      });
      instance.$mount(); // pass nothing
      $("#myModal2").modal("hide");
    },
    getDates: function (startDate, endDate) {
      var dates = [],
        currentDate = startDate,
        addDays = function (days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };
      dates.push(currentDate);
      while (currentDate <= endDate) {
        currentDate = addDays.call(currentDate, 1);
        dates.push(currentDate);
      }

      return dates;
    },
    createAvailableMeetingSlots: function (attendeeId) {
      var availableSlot = [];
      var AvailabilityFromTime;
      var AvailabilityToTime;
      var AvailableMeetingSlotsId;
      // var AvailableMeetingSlots=[];
      if (self.MeetingSettings.AvailabilityFromTime != null) {
        AvailabilityFromTime = Math.round(
          self.MeetingSettings.AvailabilityFromTime / 3600
        );
      }
      if (self.MeetingSettings.AvailabilityToTime != null) {
        AvailabilityToTime = Math.round(
          self.MeetingSettings.AvailabilityToTime / 3600
        );
      }
      //
      availableSlot.push(
        moment(AvailabilityFromTime, ["h:mm A"]).format("hh:mm A")
      );

      var StartSlotTime = moment(AvailabilityFromTime, ["h:mm A"]);
      var EndSlotTime = moment(AvailabilityToTime, ["h:mm A"]);

      for (let i = AvailabilityFromTime; StartSlotTime < EndSlotTime; i++) {
        let time = moment(availableSlot[i - AvailabilityFromTime], ["h:mm A"])
          .add(self.MeetingSettings.Slot, "minutes")
          .format("hh:mm A");

        availableSlot.push(time);
        StartSlotTime = moment(time, ["h:mm A"]);
      }

      var MSobj = JSON.parse(window.localStorage.getItem("my-app"));

      var MeetingStartDate = new Date();

      var MeetingEndDate = new Date();

      if (MSobj.MeetingSettings.length > 0) {
        if (MSobj.MeetingSettings[0].StartDate !== undefined);
        {
          if (MSobj.MeetingSettings[0] != []) {
            MeetingStartDate = new Date(
              MSobj.MeetingSettings[0].StartDate.seconds * 1000
            );
          }
        }
      }

      if (MSobj.MeetingSettings.length > 0) {
        if (MSobj.MeetingSettings[0].EndDate !== undefined);
        {
          if (MSobj.MeetingSettings[0] != []) {
            MeetingEndDate = new Date(
              MSobj.MeetingSettings[0].EndDate.seconds * 1000
            );
          }
        }
      }

      var dates = self.getDates(MeetingStartDate, MeetingEndDate);

      dates.forEach(function (MeetingsDate) {
        console.log(MeetingsDate);

        for (let i = 0; i < availableSlot.length - 1; i++) {
          //

          AvailableMeetingSlotsId =
            moment(MeetingsDate).format("MMMDD") +
            "_" +
            availableSlot[i] +
            "_" +
            availableSlot[i + 1];

          self.SaveAvailableMeetingSlots(attendeeId, AvailableMeetingSlotsId);
        }
      });
    },
    SaveAvailableMeetingSlots: function (attendeeId, AvailableMeetingSlotsId) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var AvailableMeetingSlots = "AvailableMeetingSlots";
      var MeetingTime = AvailableMeetingSlotsId.split("_");

      db.collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(attendeeId)
        .collection(AvailableMeetingSlots)
        .get()
        .then(function (res) {
          //console.log(res.size);
          if (res.size == 0) {
            var MdocRef = db
              .collection(obj.eventcollectionname)
              .doc("AttendeeList")
              .collection("Attendees")
              .doc(attendeeId)
              .collection(AvailableMeetingSlots)
              .doc(AvailableMeetingSlotsId);

            MdocRef.get()
              .then(function (doc) {
                if (!doc.exists) {
                  //

                  var docObj = new Object();
                  docObj.AvailableMeetingSlotsId = AvailableMeetingSlotsId;
                  docObj.StartDate = MeetingTime[0];
                  docObj.StartDatetime = MeetingTime[1];
                  docObj.EndDateTime = MeetingTime[2];

                  MdocRef.set(docObj)
                    .then(function () {
                      //console.log("AvailableMeetingSlots Created ");
                    })
                    .catch(function (error) {
                      console.error("Error AvailableMeetingSlots: ", error);
                    });
                }
              })
              .catch(function (error) {
                console.error("Error creating AvailableMeetingSlots: ", error);
              });
          }
        });
    },
    getBookmarkStatus(attendeeId, name, image, isBookmarked, isLoading) {
      if (isBookmarked == undefined && !isLoading) {
        console.log("isBookmarked: " + isBookmarked);
        console.log("isLoading: " + isLoading);
        var attendees = self.attendeeData.filter(function (objAttendee) {
          return objAttendee.id == attendeeId;
        });
        if (attendees.length > 0) {
          if (attendees[0].isBookmarked == undefined) {
            attendees[0].isBookmarked = false;
          }
          attendees[0].isLoading = true;
          self.attendeeData = self.attendeeData.filter(function () {
            return true;
          });
          var rqstData = {
            key: {
              instanceId: "OA_UAT",
              clientId: this.$store.state.client[0].id,
              eventId: this.$store.state.eventid,
            },
            data: {
              eventName: this.$store.state.eventname,
              enetityUserId: this.$store.state.userId,
              attendeeId: this.$store.state.userId,
              entityType: 3,
              entityName: name,
              entityImage: image,
              entityId: attendeeId,
            },
          };
          try {
            axios({
              method: "post",
              url: self.APIs.BookmarkAPIConfig.Get,
              data: rqstData,
            }).then(function (response) {
              if (
                response &&
                response.data &&
                response.data.isPublished != undefined
              ) {
                attendees[0].isBookmarked = response.data.isPublished;
              }
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
              attendees[0].isLoading = false;
            });
          } catch (e) {
            attendees[0].isBookmarked = false;
            attendees[0].isLoading = false;
            self.attendeeData = self.attendeeData.filter(function () {
              return true;
            });
            console.log(e);
          }
        }
      }
    },
    SendEmail() {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      var email = document.getElementById("modalEmail").innerText.trim();
      //alert(email);
      //window.location.href = "mailto:" + email+"?target=_blank";
      window.open("mailto:" + email + "?target=_blank");
    },
    openModal: async function (
      attendeeid,
      Name,
      Company,
      Title,
      Image,
      Email,
      Phone,
      Website,
      profile,
      sLinks,
      Initials,
      RegistrationType,
      DynamicFields,
      attendee = null
    ) {
      $("#myModal2").modal("show");
      self.currentAttendeeName = Name;
      console.log("Inside modal");
      if (Image) self.imageExists = true;
      else {
        self.imageExists = false;
      }
      //self.requestMeetingKey++;
      self.currentAttendee = attendee;
      // self.currentAttendee.Designation = attendee.Title;
      // self.currentAttendee.ProfilePictureURL = attendee.Image;
      this.isBookmarked = false;
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 3,
          entityName: this.currentAttendee.Name,
          entityImage: this.currentAttendee.Image
            ? this.currentAttendee.Image
            : "",
          entityId: this.currentAttendee.id,
        },
      };

      if (attendeeid == self.loggedInUseID) {
        $("#divRequestWrap").hide();
      } else {
        $("#divRequestWrap").show();
      }
      if (self.ShowMeetingButton) {
        if (self.allowMeeting(RegistrationType)) {
          //alert(self.loggedInUseID);
          //debugger;
          if (!self.restrictedAttendeeIDs.includes(self.loggedInUseID)) {
            $("#btnOpenRequestMeeting").show();
          } else {
            $("#btnOpenRequestMeeting").hide();
          }
        } else {
          $("#btnOpenRequestMeeting").hide();
        }
      }
      console.log("RegistrationType - " + RegistrationType);
      if (Image) {
        $("#imgModalAttendee").attr("src", self.getCDNUrl(Image));
        $("#imgModalAttendeeEnlarge").attr("src", self.getCDNUrl(Image));
        if (RegistrationType.ColorCode)
          $("#dvImgeHld").attr(
            "style",
            "border:3px solid " + RegistrationType.ColorCode
          );
        else $("#dvImgeHld").attr("style", "");
        $("#imgModalAttendee").show();
        // document.getElementById("dvImgeHld").innerText = "";
        document.getElementById("dvImgeHldText").innerText = "";
        $("#dvImgeHldText").hide();
        $("#dvImgeHld").show();
      } else {
        /* $("#imgModalAttendee").attr(
          "src",
          "../assets/Images/new-attendee-img.jpg"
        );*/
        $("#imgModalAttendee").attr("src", "");
        $("#imgModalAttendee").hide();
        if (RegistrationType.ColorCode)
          $("#dvImgeHldText").attr(
            "style",
            "border:3px solid " + RegistrationType.ColorCode
          );
        else $("#dvImgeHldText").attr("style", "");
        document.getElementById("dvImgeHldText").innerText = Initials;
        $("#dvImgeHldText").show();
        $("#dvImgeHld").hide();
      }

      $("#hdnAttendeeId").val(attendeeid);

      document.getElementById("modalName").innerText = Name;
      document.getElementById("modalCompany").innerText = Company;
      document.getElementById("modalTtile").innerText = Title;
      document.getElementById("modalEmail").innerText = Email;
      document.getElementById("modalPhone").innerText = Phone;

      if (RegistrationType != undefined) {
        if (RegistrationType != "") {
          // $("#ulContact").append(
          //   "<li id='modalRegistrationType' class='text-justify'>" +
          //     RegistrationType +
          //     "</li>"
          // );
          document.getElementById("modalRegistrationType").innerText =
            typeof RegistrationType == "object"
              ? RegistrationType.RegistrationType
              : RegistrationType;
          $("#modalRegistrationType").show();
        } else {
          $("#modalRegistrationType").hide();
        }
      } else {
        $("#modalRegistrationType").hide();
      }

      //   Website = "ws.e2m.live";
      if (Website != "") {
        document.getElementById("anchmodalWebsite").innerText = Website;
        if (Website.includes("https://")) {
          document.getElementById("anchmodalWebsite").href = Website;
          $("#modalWebsite").show();
        } else {
          document.getElementById("anchmodalWebsite").href =
            "https://" + Website;
          $("#modalWebsite").show();
        }
      } else {
        $("#modalWebsite").hide();
      }
      document.getElementById("modalProfile").innerHTML = profile;

      $("#spnFacebook").hide();
      $("#spnTwitter").hide();
      $("#spnLinkedIn").hide();
      //
      var showFB = 0;
      var showTwitter = 0;
      var showLinkedIn = 0;

      $("#modalEmail").attr(
        "data-tag",
        "attendee-" +
          document.getElementById("modalName").innerText +
          "-" +
          Email
      );
      // $("#btnShowSendMessageButton").attr(
      //   "href",
      //   "mailto:" + document.getElementById("modalEmail").innerText.trim()
      // );
      if (
        document.getElementById("ReqAttendeePhone") &&
        document.getElementById("ReqAttendeePhone").href
      ) {
        $("#modalPhone").attr(
          "data-tag",
          "attendee-" +
            document.getElementById("modalName").innerText +
            "-" +
            document.getElementById("ReqAttendeePhone").href
        );
      }

      $("#anchmodalWebsite").attr(
        "data-tag",
        "attendee-" +
          document.getElementById("modalName").innerText +
          "-" +
          document.getElementById("anchmodalWebsite").href
      );
      $("#btnOpenRequestMeeting").attr(
        "data-tag",
        "attendee- " +
          document.getElementById("modalName").innerText +
          " -OpenRequestMeeting"
      );
      // $("#btnShowSendMessageButton").attr(
      //   "data-tag",
      //   "attendee- " +
      //     document.getElementById("modalName").innerText +
      //     " -SendMessage"
      // );

      sLinks.forEach((sLink) => {
        if (sLink["Facebook"] != undefined) {
          if (sLink["Facebook"] != "") {
            showFB++;
            if (sLink["Facebook"].includes("https://")) {
              document.getElementById("anchFacebook").href = sLink["Facebook"];
              $("#anchFacebook").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["Facebook"]
              );
              $("#spnFacebook").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["Facebook"]
              );
              $("#iFacebook").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["Facebook"]
              );
            } else {
              document.getElementById("anchFacebook").href =
                "https://" + sLink["Facebook"];
              $("#anchFacebook").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["Facebook"]
              );
              $("#spnFacebook").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["Facebook"]
              );
              $("#iFacebook").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["Facebook"]
              );
            }
          }
        }

        if (sLink["Twitter"] != undefined) {
          if (sLink["Twitter"] != "") {
            showTwitter++;
            if (sLink["Twitter"].includes("https://")) {
              document.getElementById("anchTwitter").href = sLink["Twitter"];
              $("#anchTwitter").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["Twitter"]
              );
              $("#spnTwitter").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["Twitter"]
              );
              $("#iTwitter").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["Twitter"]
              );
            } else {
              document.getElementById("anchTwitter").href =
                "https://" + sLink["Twitter"];
              $("#anchTwitter").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["Twitter"]
              );
              $("#spnTwitter").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["Twitter"]
              );
              $("#iTwitter").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["Twitter"]
              );
            }
          }
        }

        if (sLink["LinkedIn"] != undefined) {
          if (sLink["LinkedIn"] != "") {
            showLinkedIn++;
            if (sLink["LinkedIn"].includes("https://")) {
              document.getElementById("anchLinkedIn").href = sLink["LinkedIn"];
              $("#anchLinkedIn").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["LinkedIn"]
              );
              $("#spnLinkedIn").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["LinkedIn"]
              );
              $("#iLinkedIn").attr(
                "data-tag",
                "Attendee - " + Name + "-" + sLink["LinkedIn"]
              );
            } else {
              document.getElementById("anchLinkedIn").href =
                "https://" + sLink["LinkedIn"];
              $("#anchLinkedIn").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["LinkedIn"]
              );
              $("#spnLinkedIn").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["LinkedIn"]
              );
              $("#iLinkedIn").attr(
                "data-tag",
                "Attendee - " + Name + "-" + "https://" + sLink["LinkedIn"]
              );
            }
          }
        }
      });
      if (showFB > 0) {
        $("#spnFacebook").show();
      }
      if (showTwitter > 0) {
        $("#spnTwitter").show();
      }
      if (showLinkedIn > 0) {
        $("#spnLinkedIn").show();
      }

      //self.deleteAvailableSolts(attendeeid);
      //var obj1 = JSON.parse(window.localStorage.getItem("my-app"));
      // self.createAvailableMeetingSlots(obj1.user[0].id);
      // self.createAvailableMeetingSlots(attendeeid);

      if (self.StaticFieldsExcludeOptions) {
        if (
          self.StaticFieldsExcludeOptions.RegistrationType != undefined &&
          self.StaticFieldsExcludeOptions.RegistrationType == false
        ) {
          $("#modalRegistrationType").hide();
        }
        if (
          self.StaticFieldsExcludeOptions.Company != undefined &&
          self.StaticFieldsExcludeOptions.Company == false
        ) {
          $("#modalCompany").hide();
        }
        if (
          self.StaticFieldsExcludeOptions.Title != undefined &&
          self.StaticFieldsExcludeOptions.Title == false
        ) {
          $("#modalTtile").hide();
        }
        if (
          self.StaticFieldsExcludeOptions.Email != undefined &&
          self.StaticFieldsExcludeOptions.Email == false
        ) {
          $("#modalEmail").hide();
        }
        if (
          self.StaticFieldsExcludeOptions.Phone != undefined &&
          self.StaticFieldsExcludeOptions.Phone == false
        ) {
          $("#modalPhone").hide();
        }
        if (
          self.StaticFieldsExcludeOptions.Website != undefined &&
          self.StaticFieldsExcludeOptions.Website == false
        ) {
          $("#modalWebsite").hide();
        }
      }

      //------------------Dynamic Profile Information----------------------------------------
      var dynamicContent = "";
      //var inicr = 0;

      if (DynamicFields) {
        //DynamicFields.sort(function (a, b) {
        //  let ai = a.index;
        //  let bi = b.index;
        //  if (ai < bi) {
        //    return -1;
        //  }
        //  if (ai > bi) {
        //    return 1;
        //  }
        //  return 0;
        //});
        let maxIndex = 0;
        $.each(DynamicFields, function (k1, v1) {
          //alert(v1.index);
          if (v1.index > maxIndex) {
            maxIndex = v1.index;
          }
        });
        //Object.keys(DynamicFields).forEach(function (item) {
        //  alert(item);
        //  alert(DynamicFields[item].index);
        //});
        //alert(maxIndex);
        //maxIndex = 5;
        //alert(maxIndex);
        //self.DynamicFieldsExcludeOptions.map(function (item) {
        //  //alert("item:" + item);
        //});
        //$.each(DynamicFields, function (k1, v1) {
        //  //alert("key:" + k1 + " value:" + v1);
        //});
        //$.each(DynamicFields, function (k1, v1) {
        for (var index = 0; index <= maxIndex; index++) {
          //alert("key:" + k1 + " value:" + v1);
          //console.log("key:- " + k1);
          //console.log("index:- " + v1);
          //alert("out:" + k1);

          //$.each(DynamicFields, function (k, v) {
          Object.keys(DynamicFields).forEach(function (k) {
            //let k = item;
            let v = DynamicFields[k];

            if (index == v.index) {
              //alert("in:" + k);
              //alert("key:" + k + " value:" + v);
              let displayField = true;
              if (
                self.DynamicFieldsExcludeOptions &&
                self.DynamicFieldsExcludeOptions.includes(k.toString())
              ) {
                displayField = false;
                //alert("includes:" + k);
              }
              //let fields = self.DynamicFieldsExcludeOptions.filter(function (
              //  item
              //) {
              //  //alert("item:" + item);
              //  return item == k.toString();
              //});
              //if (fields.length > 0) {
              //  displayField = false;
              //  //alert("includes:" + k);
              //}
              //if (displayField && v.value != "") {
              if (displayField) {
                //console.log(
                //  "key:" +
                //    k +
                //    " field_type:" +
                //    v.field_type +
                //    " value:" +
                //    v.value
                //);
                if (v.field_type == "radio") {
                  if (v.label && v.value) {
                    dynamicContent =
                      dynamicContent +
                      "<div class='edit-panel-cvr'><div><p><strong>" +
                      v.label +
                      "</strong><strong>:</strong></p><p><span>" +
                      v.value +
                      "</span></p></div></div>";
                  }
                }

                if (v.field_type == "checkboxes") {
                  if (v.label && v.value) {
                    dynamicContent =
                      dynamicContent +
                      "<div class='edit-panel-cvr'><div><p><strong>" +
                      v.label +
                      "</strong><strong>:</strong></p><p><span>" +
                      v.value +
                      "</span></p></div></div>";
                  }
                }
                //alert(k);
                if (v.field_type == "text" || v.Type == "text") {
                  if (v.label && v.value) {
                    dynamicContent =
                      dynamicContent +
                      "<div class='edit-panel-cvr'><div><p><strong>" +
                      v.label +
                      "</strong><strong>:</strong></p><p><span>" +
                      v.value +
                      "</span></p></div></div>";
                  }
                }

                if (v.field_type == "dropdown") {
                  if (v.label && v.value) {
                    dynamicContent =
                      dynamicContent +
                      "<div class='edit-panel-cvr'><div><p><strong>" +
                      v.label +
                      "</strong><strong>:</strong></p><p><span>" +
                      v.value +
                      "</span></p></div></div>";
                  }
                }
                if (v.field_type == "email") {
                  if (v.label && v.value) {
                    dynamicContent =
                      dynamicContent +
                      "<div class='edit-panel-cvr'><div><p><strong>" +
                      v.label +
                      "</strong><strong>:</strong></p><p><span>" +
                      v.value +
                      "</span></p></div></div>";
                  }
                }
                if (v.field_type == "paragraph") {
                  if (v.label && v.value) {
                    dynamicContent =
                      dynamicContent +
                      "<div class='edit-panel-cvr'><div><p><strong>" +
                      v.label +
                      "</strong><strong>:</strong></p><p><span>" +
                      v.value +
                      "</span></p></div></div>";
                  }
                }
              }
            } else {
              if (v.Type == "radio") {
                if (v.Label && v.Value) {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.Label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.Value +
                    "</span></p></div></div>";
                }
              }

              if (v.Type == "checkboxes") {
                if (v.Label && v.Value) {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.value +
                    "</span></p></div></div>";
                }
              }
              //alert(k);
              if (v.Type == "text") {
                if (v.Label && v.Value) {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.Label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.Value +
                    "</span></p></div></div>";
                }
              }

              if (v.Type == "select") {
                if (v.Label && v.Value) {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.Label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.Value +
                    "</span></p></div></div>";
                }
              }
              if (v.Type == "multiselect") {
                if (v.Label && v.Value) {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.Label +
                    "</strong></p>";

                  v.Value.map((val) => {
                    dynamicContent =
                      dynamicContent +
                      "<p><span>" +
                      val +
                      "</span></p></div></div>";
                  });
                }
              }

              if (v.Type == "email") {
                if (v.Label && v.Value) {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.Label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.Value +
                    "</span></p></div></div>";
                }
              }
              if (v.Type == "paragraph") {
                if (v.Label && v.Value) {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.Label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.Value +
                    "</span></p></div></div>";
                }
              }
            }
          });
          //inicr++;
        }
        //);
      }
      //------------------------------------------------------------------------------------
      //document.getElementById("divDynamicContent").innerText = "";
      $("#divDynamicContent").html(dynamicContent);
      this.postLeaderboardAction("ATVW");
      try {
        let bookmarkExists = await axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Get,
          data: rqstData,
        });
        if (bookmarkExists.data && bookmarkExists.data.isPublished)
          this.isBookmarked = true;
        else this.isBookmarked = false;
      } catch (e) {
        console.log(e);
        this.isBookmarked = false;
      }
    },
    searchAttendee2: function () {
      //if (self.searchtext == "") {
      $("#dvAttendeeWrapper").html("");
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.pageCount = 0;
      hasMore = true;
      lastVisible = null;
      self.attendeeData = [];

      //self.displayAttendees();
      self.applyFilter();
      //}
    },
    searchAttendee: function () {
      //$("#dvAttendeeWrapper").html("");
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.pageCount = 0;
      hasMore = true;
      lastVisible = null;
      self.attendeeData = [];
      self.applyFilter();
      //$("#dvAttendeeWrapper").html("");
    },
    closeModal: function () {
      $("#myModal2").modal("hide");

      // $("#dvBackDrop").hide();
      // $("#dvBackDrop").removeClass("show");
      // router.push("/attendee");
    },
    displayAttendees(requestData) {
      self.showLoader();
      console.log(hasMore);
      console.log(lastVisible);

      //var search = [];
      //let searchText = self.searchtext.trim().toLowerCase();
      //if (searchText) {
      //  search.push({
      //    key: "Name",
      //    operator: "LIKE",
      //    value: searchText,
      //  });
      //  search.push({
      //    key: "Company",
      //    operator: "LIKE",
      //    value: searchText,
      //  });
      //  search.push({
      //    key: "Designation",
      //    operator: "LIKE",
      //    value: searchText,
      //  });
      //  //search.push({
      //  //  key: "Tags",
      //  //  operator: "array-contains-any",
      //  //  value: searchText,
      //  //});
      //}
      self.pageIndex++;
      //requestData.search = search;
      requestData.pagination = {
        Page: self.pageIndex,
        PageSize: self.pageSize,
      };
      requestData.origin = self.isAdminComponent ? "CMS" : "WEB";

      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      let keys = {
        instanceId: "OA_UAT",
        clientId: self.clientID, // "C1591205467009",
        eventId: self.eventId, //"E1591206650065",
      };
      let rqstData = {};
      //if (requestData.filter.length > 0) {
      rqstData = {
        key: keys,
        data: requestData,
      };
      //} else {
      //  rqstData = {
      //    key: keys,
      //    data: {
      //      pagination: {
      //        Page: self.pageIndex,
      //        PageSize: self.pageSize,
      //      },
      //    },
      //  };
      //}
      //pageSize: 1000,
      //pageIndex: 1,
      debugger;
      axios
        .post(self.APIs.AttendeeSearch, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          self.hideLoader();
          if (responseData && responseData.data && responseData.data.result) {
            let data = responseData.data.result;
            self.pageCount = responseData.data.pagination.TotalPages;
            //self.attendeeData = [];
            for (var i = 0; i < data.length; i++) {
              var filteredRows = self.attendeeData.filter(function (value) {
                return (
                  value.id ==
                  (data[i].AttendeeId != undefined ? data[i].AttendeeId : "")
                );
              });

              if (filteredRows.length == 0) {
                //if (data[i].AttendeeId == "51024") {
                //  console.log(data[i]);
                //  alert(data[i].IsPublished);
                //  debugger;
                //}
                if (
                  data[i].ShowInCMSAttendeeList == 1 ||
                  data[i].ShowInCMSAttendeeList == undefined
                ) {
                  var objAttendee = {
                    id:
                      data[i].AttendeeId != undefined
                        ? data[i].AttendeeId
                        : "0",
                    attendeeId:
                      data[i].AttendeeId != undefined
                        ? data[i].AttendeeId
                        : "0",
                    AttendeeId:
                      data[i].AttendeeId != undefined
                        ? data[i].AttendeeId
                        : "0",
                    Name:
                      (data[i].FirstName != undefined
                        ? data[i].FirstName
                        : "") +
                      " " +
                      (data[i].LastName != undefined ? data[i].LastName : ""),
                    FirstName:
                      data[i].FirstName != undefined ? data[i].FirstName : "",
                    LastName:
                      data[i].LastName != undefined ? data[i].LastName : "",
                    Email: data[i].Email != undefined ? data[i].Email : "",
                    Image:
                      data[i].ProfilePictureURL != undefined
                        ? self.getCDNUrl(data[i].ProfilePictureURL)
                        : "",
                    ProfilePictureURL:
                      data[i].ProfilePictureURL != undefined
                        ? self.getCDNUrl(data[i].ProfilePictureURL)
                        : "",
                    Title:
                      data[i].Designation != undefined
                        ? data[i].Designation
                        : "",
                    Designation:
                      data[i].Designation != undefined
                        ? data[i].Designation
                        : "",
                    Country:
                      data[i].Country != undefined ? data[i].Country : "",
                    Company:
                      data[i].Company != undefined ? data[i].Company : "",
                    Profile:
                      data[i].Profile != undefined ? data[i].Profile : "",
                    Phone: data[i].Phone != undefined ? data[i].Phone : "",
                    Website:
                      data[i].Website != undefined ? data[i].Website : "",
                    SocialLinks:
                      data[i].SocialLinks != undefined
                        ? data[i].SocialLinks
                        : [],
                    Initials: common.getInitials(
                      (data[i].FirstName != undefined
                        ? data[i].FirstName
                        : "") +
                        " " +
                        (data[i].LastName != undefined ? data[i].LastName : "")
                    ),

                    RegistrationType: data[i].RegistrationType
                      ? data[i].RegistrationType
                      : "",
                    DynamicFields: data[i].DynamicFields
                      ? data[i].DynamicFields
                      : [],
                    Tags: data[i].Tags ? data[i].Tags : "",
                    IsPublished:
                      data[i].IsPublished != undefined
                        ? data[i].IsPublished
                        : true,
                    HideInList: data[i].HideInList ? data[i].HideInList : false,
                  };
                  objAttendee.FirstName = objAttendee.FirstName.trim();
                  objAttendee.LastName = objAttendee.LastName.trim();
                  objAttendee.Name =
                    objAttendee.FirstName + " " + objAttendee.LastName;

                  var sLinks = objAttendee.SocialLinks;
                  sLinks.forEach((sLink) => {
                    if (sLink["Facebook"] != undefined) {
                      objAttendee.Facebook =
                        sLink["Facebook"] == undefined ? "" : sLink["Facebook"];
                    }
                    if (sLink["Twitter"] != undefined) {
                      objAttendee.Twitter =
                        sLink["Twitter"] == undefined ? "" : sLink["Twitter"];
                    }
                    if (sLink["LinkedIn"] != undefined) {
                      objAttendee.LinkedIn =
                        sLink["LinkedIn"] == undefined ? "" : sLink["LinkedIn"];
                    }
                    if (sLink["GooglePlus"] != undefined) {
                      objAttendee.GooglePlus =
                        sLink["GooglePlus"] == undefined
                          ? ""
                          : sLink["GooglePlus"];
                    }
                  });
                  objAttendee.isOnline = self.getAttendeeLoggedInStatus(
                    data[i].AttendeeId
                  );
                  //if (objAttendee.attendeeId == "221000") {
                  //  alert(objAttendee.IsPublished);
                  //  alert(objAttendee.HideFromList);
                  //}
                  //let flag = false;
                  //if (ShowSpeakerInAttendee == false) {
                  //  if (speakersList2.indexOf(objAttendee.AttendeeId) < 0) {
                  //    flag = true;
                  //  }
                  //} else {
                  //  flag = true;
                  //}

                  //if (flag) {
                  objAttendee.AttendeeKey = parseInt(objAttendee.AttendeeId);
                  self.attendeeData.push(objAttendee);
                  //}
                }
              }
            }
            //if (self.attendeeData.length > 0) {
            //  self.IsShowNoDataFound = false;
            //} else {
            //  self.IsShowNoDataFound = true;
            //}
          }
        })
        .catch((error) => {
          self.hideLoader();
          //
          //self.IsShowNoDataFound = true;
          console.log("Error:" + error);

          return false;
        });
      // lastVisible = null;
    },
    getArrayTrimString: function (tags) {
      var RetArray = [];
      $.each(tags.split(","), function () {
        RetArray.push($.trim(this));
      });
      return RetArray;
    },
    getEventID() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.eventid;
    },
    //getInitials: function (str) {
    //  // alert(str);
    //  //var str = "Java Script Object Notation";
    //  var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    //  var acronym = "";
    //  if (matches != null) {
    //    acronym = matches.join(""); // JSON
    //  }
    //  return acronym;
    //  //console.log(acronym);
    //},
    scroll: function () {
      //if (self.searchtext.length <= 0) {
      //if (!self.hasFilterOrSearch) {
      //window.onscroll = () => {
      //alert("scroll");
      //if (!self.IsSearchMode) {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.offsetHeight;
      //alert(document.getElementsByClassName("v-main")[0].scrollTop);
      //debugger;
      //alert(
      //  "document.documentElement.scrollTop: " +
      //    document.documentElement.scrollTop
      //);
      //alert("window.innerHeight: " + window.innerHeight);
      //alert(
      //  "document.documentElement.offsetHeight: " +
      //    document.documentElement.offsetHeight
      //);
      //alert(bottomOfWindow);
      if (self.AttendeeSettingsLoaded && bottomOfWindow) {
        //alert("scroll");
        //if (self.searchtext.trim() == "") {
        //if (!self.hasFilterOrSearch) {
        //self.displayAttendees();
        //self.applyFilter();
        //}
      }
      //}
      //};
      //}
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
      self.IsLoading = true;
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(self.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
      self.IsLoading = false;
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              self.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                self.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          self.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            self.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      self.AddAnalitics(event, "click");
      //self.hideFilter();
    },
    // onScrollHandler(event) {
    //   // event.target is the clicked element object
    //   self.AddAnalitics(event, "scroll");
    // },
    OnIdUrl: function (obj) {
      var found_attendee = [];
      if (self.$route.params.aid !== undefined) {
        if (self.$route.params.aid !== "") {
          found_attendee = obj.filter(function (e) {
            return e.AttendeeId === self.$route.params.aid;
          });
          if (found_attendee.length > 0) {
            //alert(self.$route.params.aid);
            //var aid = self.$route.params.aid;
            //  console.log(aid);

            //$('#'+aid).click();
            //$('div[id='+aid+']').click();
            //$('#myModal2').css("display","block");
            //$('div[id = "dv'+aid+'"]').trigger('click');
            self.openModal(
              found_attendee[0].id,
              found_attendee[0].Name,
              found_attendee[0].Company,
              found_attendee[0].Title,
              found_attendee[0].Image,
              found_attendee[0].Email,
              found_attendee[0].Phone,
              found_attendee[0].Website,
              found_attendee[0].Profile,
              found_attendee[0].SocialLinks,
              found_attendee[0].Initials,
              found_attendee[0].RegistrationType,
              found_attendee[0].DynamicFields
            );
            $("#myModal2").modal("show");
            clearInterval(interval);
          }
        }
      }
    },

    fetchRegistrationType() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var lstRegTypes = db
        .collection(obj.eventcollectionname)
        .doc("RegistrationTicketList")
        .collection("RegistrationTicketTypes");
      lstRegTypes.get().then((querySnapshot) => {
        if (querySnapshot.docs.length > 1) {
          this.regTypes.push({
            ColorCode: "",
            RegistrationType: "All",
            RegistrationTypeId: "",
          });
        }
        querySnapshot.forEach((doc) => {
          var data = doc.data();
          if (data.IsPublished) {
            this.regTypes.push(data);
          }
        });
      });
    },
    mob_alist_search() {
      $("#mob_att_search").css("display", "flex");
      $(".mob_search_button").css("opacity", "0 ");
    },
  },
};
</script>
